package com.raouf.mehrguard.web.i18n

internal val ChineseStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Kotlin 多平台 QRishing 检测器",
    WebStringKey.MenuMain to "主菜单",
    WebStringKey.MenuSecurity to "安全",
    WebStringKey.MenuSystem to "系统",
    WebStringKey.NavDashboard to "仪表盘",
    WebStringKey.NavScanMonitor to "扫描监控",
    WebStringKey.NavScanHistory to "扫描历史",
    WebStringKey.NavTrustCentre to "信任中心",
    WebStringKey.NavReports to "报告",
    WebStringKey.NavTraining to "培训",
    WebStringKey.NavSettings to "设置",
    WebStringKey.QuickActions to "快速操作",
    WebStringKey.HeroTagline to "安全。离线。",
    WebStringKey.HeroTagline2 to "可解释的防御。",
    WebStringKey.HeroDescription to "Mehr Guard 直接在您的硬件上分析潜在威胁。体验零延迟保护。",
    WebStringKey.StartScan to "开始新扫描",
    WebStringKey.ImportImage to "导入图片",
    WebStringKey.ScanQrCode to "扫描二维码",
    WebStringKey.SystemHealth to "系统健康",
    WebStringKey.ThreatDatabase to "威胁数据库",
    WebStringKey.Current to "当前",
    WebStringKey.Active to "活跃",
    WebStringKey.Threats to "威胁",
    WebStringKey.SafeScans to "安全扫描",
    WebStringKey.EngineActive to "引擎活跃",
    WebStringKey.EnterpriseProtection to "企业保护已启用",
    WebStringKey.SystemOptimal to "系统最优",
    WebStringKey.EngineStatus to "引擎 v2.4 • 2小时前更新",
    WebStringKey.ThreatsBlocked to "已阻止威胁",
    WebStringKey.AllSystemsOperational to "所有系统正常运行",
    WebStringKey.SectionOverview to "概览",
    WebStringKey.SectionSecurity to "安全",
    WebStringKey.SectionTraining to "培训",
    WebStringKey.SectionReports to "报告",
    WebStringKey.OfflineReady to "离线就绪",
    WebStringKey.OfflineDescription to "本地数据库 v2.4.1 已激活。无数据离开此设备。",
    WebStringKey.TrustCentreTitle to "信任中心",
    WebStringKey.OfflineGuarantee to "严格离线保证",
    WebStringKey.OfflineGuaranteeDesc to "Mehr Guard 分析完全在您设备的神经引擎上运行。URL数据永远不会离开您的手机。",
    WebStringKey.ThreatSensitivity to "威胁敏感度",
    WebStringKey.ResetConfirm to "此操作将把所有信任中心设置重置为默认值。",
    WebStringKey.ThreatMonitor to "威胁监控",
    WebStringKey.ThreatMonitorDesc to "查看实时威胁并运行安全检查。",
    WebStringKey.TrustCentreDesc to "隐私和威胁敏感度设置。",
    WebStringKey.ExportReport to "导出报告",
    WebStringKey.ExportReportDesc to "生成PDF或JSON安全报告。",
    WebStringKey.Analyze to "分析",
    WebStringKey.HeuristicEngine to "启发式引擎",
    WebStringKey.HighPerformanceEngine to "高性能引擎",
    WebStringKey.RecentScans to "最近扫描",
    WebStringKey.ViewFullHistory to "查看完整历史",
    WebStringKey.Status to "状态",
    WebStringKey.Source to "来源",
    WebStringKey.Details to "详情",
    WebStringKey.Time to "时间",
    WebStringKey.Version to "版本",
    WebStringKey.LastUpdate to "最后更新",
    WebStringKey.Signatures to "签名",
    WebStringKey.CheckForUpdates to "检查更新",
    WebStringKey.FeatureOfflineTitle to "离线优先架构",
    WebStringKey.FeatureOfflineDesc to "完整分析在本地执行。您的摄像头画面和扫描数据绝不会接触外部服务器。",
    WebStringKey.FeatureExplainableTitle to "可解释的安全性",
    WebStringKey.FeatureExplainableDesc to "不仅仅是「拦截」。我们提供有关 URL 参数的详细启发式细分。",
    WebStringKey.FeaturePerformanceDesc to "针对桌面环境进行了优化。使用原生 Kotlin Multiplatform 二进制文件在 5 毫秒内处理扫描。",
    WebStringKey.TrainingCentre to "培训中心",
    WebStringKey.LearnHomograph to "学习如何识别高级 QR 同形异义字攻击。",
    WebStringKey.BeatTheBotAction to "击败机器人 →",
    WebStringKey.NoScansYet to "尚无扫描。开始新的扫描以在此处查看结果。",
    WebStringKey.VerdictSafe to "安全",
    WebStringKey.VerdictPhish to "钓鱼",
    WebStringKey.VerdictWarn to "警告",
    WebStringKey.ScoreLabel to "分数：",
    WebStringKey.ActiveScanner to "主动扫描仪",
    WebStringKey.OfflineMode to "离线模式",
    WebStringKey.LiveFeedDisconnected to "实时信号已断开",
    WebStringKey.CameraAccessRequired to "需要摄像头权限",
    WebStringKey.CameraAccessDescription to "将二维码图片拖放到此处或启用摄像头以开始扫描。",
    WebStringKey.EnableCamera to "启用摄像头",
    WebStringKey.Scanning to "正在扫描...",
    WebStringKey.ScanHint to "保持稳定。离线分析耗时 <5ms。",
    WebStringKey.Torch to "手电筒",
    WebStringKey.Gallery to "相册",
    WebStringKey.PasteUrl to "粘贴 URL",
    WebStringKey.PasteUrlTitle to "粘贴 URL 以分析",
    WebStringKey.AnalyzeUrl to "分析 URL",
    WebStringKey.SystemStatus to "系统状态",
    WebStringKey.PhishingEngine to "钓鱼引擎",
    WebStringKey.Ready to "就绪",
    WebStringKey.LocalDb to "本地数据库",
    WebStringKey.Latency to "延迟",
    WebStringKey.ViewAll to "查看全部",
    WebStringKey.BreadcrumbHome to "首页",
    WebStringKey.BreadcrumbScans to "扫描",
    WebStringKey.OfflineProtection to "离线保护",
    WebStringKey.VerdictHighRisk to "检测到高风险",
    WebStringKey.VerdictDangerous to "危险",
    WebStringKey.VerdictDangerousDesc to "扫描的二维码包含与钓鱼和凭证窃取相关的恶意指标。请勿继续访问目标 URL。",
    WebStringKey.ThreatConfidence to "威胁置信度",
    WebStringKey.FlagPhishing to "钓鱼尝试",
    WebStringKey.FlagObfuscated to "混淆脚本",
    WebStringKey.FlagHomograph to "同形异义字攻击",
    WebStringKey.ClearHistory to "清除全部",
    WebStringKey.SectionAttackBreakdown to "攻击详情",
    WebStringKey.AttackHomographTitle to "同形异义字 / IDN 攻击",
    WebStringKey.AttackHomographDesc to "检测到模仿拉丁字母的西里尔字符。",
    WebStringKey.AttackVisualLabel to "视觉外观",
    WebStringKey.AttackPunycodeLabel to "实际 Punycode",
    WebStringKey.AttackHomographExplain to "该域名使用西里尔字母代替拉丁字母，这通常用于欺骗。",
    WebStringKey.AttackRedirectTitle to "可疑重定向链",
    WebStringKey.AttackRedirectDesc to "检测到涉及已知 URL 缩短服务的 3 次跳转。",
    WebStringKey.RedirectStart to "二维码扫描",
    WebStringKey.RedirectHop to "中间跳转",
    WebStringKey.RedirectFinal to "最终目的地",
    WebStringKey.AttackJsTitle to "混淆 JavaScript",
    WebStringKey.AttackJsDesc to "在 URL 参数中检测到高熵字符串。",
    WebStringKey.SectionActions to "推荐操作",
    WebStringKey.ActionBlock to "阻止并报告",
    WebStringKey.ActionBlockDesc to "阻止访问并通知管理员。",
    WebStringKey.ActionQuarantine to "放入沙箱隔离",
    WebStringKey.ActionQuarantineDesc to "安全打开以进行分析。",
    WebStringKey.Expected to "预期: ",
    WebStringKey.Detected to "检测到: ",
    WebStringKey.ExplainableSecurity to "可解释安全",
    WebStringKey.UrlBreakdown to "URL分解",
    WebStringKey.FullUrl to "完整URL",
    WebStringKey.OpenInBrowser to "在浏览器中打开（风险）",
    WebStringKey.OpenWarning to "在浏览器中打开此URL可能会使您面临安全风险。",
    WebStringKey.RestrictedMode to "受限模式",
    WebStringKey.RestrictedDesc to "此URL已被标记为潜在有害。",
    WebStringKey.DangerousWarning to "此URL可能有害。您确定要继续吗？",
    WebStringKey.CopyUrl to "复制URL",
    WebStringKey.Share to "分享",
    WebStringKey.Dismiss to "关闭",
    WebStringKey.ReasonDomainAge to "域名注册时间少于 24 小时。",
    WebStringKey.ReasonSignatures to "匹配本地钓鱼数据库中的 3 个签名。",
    WebStringKey.ReasonAsn to "目标 IP 位于高风险 ASN 中。",
    WebStringKey.SectionMeta to "扫描元数据",
    WebStringKey.MetaTime to "扫描时间",
    WebStringKey.MetaSource to "来源",
    WebStringKey.MetaEngine to "引擎",
    WebStringKey.MetaOfflineGuaranteeLabel to "离线保证：",
    WebStringKey.MetaOfflineGuaranteeDesc to "此图像在您的设备上本地分析。没有任何数据发送到云端。",
    
    // Results Page
    WebStringKey.ScanComplete to "扫描完成",
    WebStringKey.Loading to "加载中...",
    WebStringKey.AnalyzedOffline to "离线分析 <5毫秒",
    WebStringKey.NoDataLeaves to "数据不离开设备",
    WebStringKey.ActiveProtection to "主动保护",
    WebStringKey.ConfidenceScore to "置信度分数",
    WebStringKey.Analyzing to "分析中...",
    WebStringKey.ProcessingResults to "正在处理扫描结果...",
    WebStringKey.RiskAssessment to "风险评估",
    WebStringKey.AnalysisTime to "分析时间",
    WebStringKey.Heuristics to "启发式",
    WebStringKey.TopAnalysisFactors to "主要分析因素",
    WebStringKey.Pass to "通过",
    WebStringKey.Info to "信息",
    WebStringKey.Clean to "干净",
    WebStringKey.ValidSslCertificate to "有效的SSL证书",
    WebStringKey.SslCertificateDesc to "由DigiCert Inc颁发的证书。信任链无异常。",
    WebStringKey.EstablishedDomain to "已建立的域名",
    WebStringKey.EstablishedDomainDesc to "域名注册超过5年。欺诈可能性低。",
    WebStringKey.BlacklistStatus to "黑名单状态",
    WebStringKey.BlacklistStatusDesc to "未在52个本地威胁数据库中找到。",
    WebStringKey.BackToDashboard to "返回仪表板",
    WebStringKey.ShareReport to "分享报告",
    WebStringKey.CopyLink to "复制链接",
    WebStringKey.LinkCopied to "链接已复制到剪贴板！",
    
    // Game Page
    WebStringKey.BeatTheBot to "击败机器人",
    WebStringKey.BeatTheBotDesc to "挑战我们的离线AI。你能更快发现钓鱼吗？",
    WebStringKey.SessionId to "会话ID",
    WebStringKey.EndSession to "结束会话",
    WebStringKey.Round to "回合",
    WebStringKey.BrowserPreview to "浏览器预览",
    WebStringKey.MakeDecision to "做出你的决定",
    WebStringKey.Phishing to "钓鱼",
    WebStringKey.Legitimate to "合法",
    WebStringKey.LiveHint to "实时提示",
    WebStringKey.LiveScoreboard to "实时记分板",
    WebStringKey.VsMode to "对战模式",
    WebStringKey.You to "你",
    WebStringKey.Points to "分",
    WebStringKey.Streak to "连胜",
    WebStringKey.Accuracy to "准确度",
    WebStringKey.MehrGuardBot to "Mehr Guard 机器人",
    WebStringKey.Confidence to "置信度",
    WebStringKey.RoundAnalysis to "回合分析",
    WebStringKey.Analysis to "分析",
    WebStringKey.CorrectDecision to "正确的决定！",
    WebStringKey.IdentifiedSafe to "你正确识别了安全的URL。",
    WebStringKey.AiNeuralAnalysis to "AI神经分析",
    WebStringKey.WhyBotFlagged to "机器人为何标记",
    WebStringKey.EducationalNote to "教育笔记",
    WebStringKey.Correct to "正确！",
    WebStringKey.SpottedPhishing to "你正确发现了钓鱼URL。",
    WebStringKey.Response to "响应",
    WebStringKey.NextRound to "下一回合",
    WebStringKey.GameOver to "游戏结束！",
    WebStringKey.FinalResults to "最终结果",
    WebStringKey.YourScore to "你的分数",
    WebStringKey.BotScore to "机器人分数",
    WebStringKey.BestStreak to "最佳连胜",
    WebStringKey.PlayAgain to "再玩一次",
    WebStringKey.ReturnToDashboard to "返回仪表板",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "导出安全报告",
    WebStringKey.GenerateReport to "从扫描历史生成完整的安全报告。",
    WebStringKey.ReportFormat to "报告格式",
    WebStringKey.HumanReadable to "人类可读报告",
    WebStringKey.HumanReadableDesc to "带有可视化分析和执行摘要的PDF",
    WebStringKey.MachineReadable to "机器可读数据",
    WebStringKey.MachineReadableDesc to "用于SIEM集成的JSON格式",
    WebStringKey.DateRange to "日期范围",
    WebStringKey.Last7Days to "最近7天",
    WebStringKey.Last30Days to "最近30天",
    WebStringKey.Last90Days to "最近90天",
    WebStringKey.AllTime to "所有时间",
    WebStringKey.CustomRange to "自定义范围",
    WebStringKey.ReportSections to "报告部分",
    WebStringKey.ExecutiveSummary to "执行摘要",
    WebStringKey.ThreatBreakdown to "威胁分析",
    WebStringKey.ScanTimeline to "扫描时间线",
    WebStringKey.SafeUrlList to "安全URL列表",
    WebStringKey.GenerateExport to "导出报告",
    
    // Toast / Notifications
    WebStringKey.Success to "成功！",
    WebStringKey.Error to "错误",
    WebStringKey.Warning to "警告",
    WebStringKey.CopiedToClipboard to "已复制到剪贴板",
    
    // General Actions
    WebStringKey.Cancel to "取消",
    WebStringKey.Confirm to "确认",
    WebStringKey.Save to "保存",
    WebStringKey.Delete to "删除",
    WebStringKey.Edit to "编辑",
    WebStringKey.Close to "关闭",
    WebStringKey.Back to "返回",
    WebStringKey.Next to "下一步",
    WebStringKey.Previous to "上一步",
    WebStringKey.Submit to "提交",
    WebStringKey.Reset to "重置",
    WebStringKey.Clear to "清除",
    WebStringKey.Search to "搜索",
    WebStringKey.Filter to "筛选",
    WebStringKey.Sort to "排序",
    
    // Accessibility
    WebStringKey.ToggleMenu to "切换菜单",
    WebStringKey.ToggleTheme to "切换主题",
    WebStringKey.Notifications to "通知",
    WebStringKey.Help to "帮助",
    WebStringKey.Profile to "个人资料",
    WebStringKey.ToggleLightDarkMode to "切换明暗模式",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "粘贴URL进行分析（例如：https://example.com）",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "扫描",
    WebStringKey.Result to "结果",
    WebStringKey.ReportGeneration to "报告生成",
    WebStringKey.ReportGenerationDesc to "配置格式并下载威胁分析。",
    WebStringKey.OfflineSecurity to "离线安全",
    WebStringKey.OfflineSecurityDesc to "您的数据永远不会离开此设备。所有处理都是本地的。",
    WebStringKey.ChooseFormat to "选择格式",
    WebStringKey.PdfFormatDesc to "PDF格式。适合分享。",
    WebStringKey.JsonFormatDesc to "JSON格式。适合SIEM集成。",
    WebStringKey.Copy to "复制",
    WebStringKey.LivePreview to "实时预览",
    WebStringKey.ReadOnly to "只读",
    WebStringKey.ThreatAnalysisReport to "威胁分析报告",
    WebStringKey.Verdict to "判决",
    WebStringKey.RiskScore to "风险分数",
    WebStringKey.TargetUrl to "目标URL",
    WebStringKey.AnalysisSummaryLabel to "分析摘要",
    WebStringKey.TechnicalIndicators to "技术指标",
    WebStringKey.ExportInfoNote to "导出包括所有已识别的威胁向量和载荷分析。",
    
    // Trust Centre Page
    WebStringKey.AllowList to "允许列表",
    WebStringKey.BlockList to "阻止列表",
    WebStringKey.AddDomain to "添加域名",
    WebStringKey.RemoveDomain to "删除域名",
    WebStringKey.TrustedDomains to "受信任的域名",
    WebStringKey.BlockedDomains to "已阻止的域名",
    WebStringKey.DomainPlaceholder to "输入域名（例如：example.com）",
    
    // Game Page Additional
    WebStringKey.Safe to "安全",
    WebStringKey.TimeAgo to "前",
    WebStringKey.MinutesAgo to "分钟前",
    WebStringKey.HoursAgo to "小时前",
    
    // Misc
    WebStringKey.Critical to "严重",
    WebStringKey.Warn to "警告",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "钓鱼检测敏感度",
    WebStringKey.SensitivityDescription to "调整启发式阈值。更高的敏感度可能会增加误报。",
    WebStringKey.SensitivityLow to "低",
    WebStringKey.SensitivityBalanced to "平衡",
    WebStringKey.SensitivityParanoia to "偏执",
    WebStringKey.BalancedModeRecommended to "平衡模式（推荐）",
    WebStringKey.BalancedModeDesc to "扫描已知的恶意模式和启发式不匹配。阻止同形文字攻击和重定向链。",
    WebStringKey.LowSensitivityMode to "低敏感度模式",
    WebStringKey.LowSensitivityModeDesc to "仅阻止威胁数据库中的已知恶意URL。最小化误报，但可能遗漏新型攻击。",
    WebStringKey.ParanoiaMode to "偏执模式",
    WebStringKey.ParanoiaModeDesc to "最大保护。阻止任何可疑模式，包括新注册的域名、不常见的TLD以及任何可能带有编码技巧的URL。",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard使用本地启发式分析引擎。扫描期间不会有任何图像数据、URL字符串或元数据离开此设备。您的隐私在数学上得到保证。",
    WebStringKey.SignalBrandImpersonation to "检测到潜在的品牌冒充",
    WebStringKey.SignalCredentialParams to "URL中存在与凭据相关的参数",
    WebStringKey.SignalEncodedPayload to "在查询参数中检测到编码数据",
    WebStringKey.SignalExcessiveSubdomains to "过度的子域深度（{count}级）",
    WebStringKey.SignalHighEntropyHost to "域名中的高随机性",
    WebStringKey.SignalHomographAttack to "域名包含同形字符/易混淆字符",
    WebStringKey.SignalHttpNotHttps to "使用不安全的HTTP协议",
    WebStringKey.SignalIpAddressHost to "主机是IP地址而不是域名",
    WebStringKey.SignalLongUrl to "异常长的URL（{length}个字符）",
    WebStringKey.SignalLongUrlMarketing to "异常长的URL（{length}个字符）- 包含营销参数",
    WebStringKey.SignalNewlyRegisteredDomain to "检测到新注册的域名",
    WebStringKey.SignalNonStandardPort to "非标准端口：{port}",
    WebStringKey.SignalNumericSubdomain to "检测到纯数字子域",
    WebStringKey.SignalSuspiciousPathKeywords to "路径中的可疑关键词（发现{count}个）",
    WebStringKey.SignalSuspiciousTld to "可疑的TLD：{tld}",
    WebStringKey.SignalUrlShortener to "使用URL缩短服务",
    WebStringKey.SecureEnvironment to "安全环境",
    WebStringKey.LearnLocalArchitecture to "了解我们的本地架构",
    WebStringKey.NoCustomDomainsBlocked to "没有阻止自定义域名。",
    WebStringKey.AddManually to "手动添加",
    WebStringKey.AddedDaysAgo to "2天前添加",
    WebStringKey.AddedWeekAgo to "1周前添加",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "隐私控制",
    WebStringKey.StrictOfflineMode to "严格离线模式",
    WebStringKey.DisableExternalPreviews to "禁用所有外部链接预览。",
    WebStringKey.AnonymousTelemetry to "匿名遥测",
    WebStringKey.ShareDetectionStats to "分享检测统计以改进ML。",
    WebStringKey.AutoCopySafeLinks to "自动复制安全链接",
    WebStringKey.CopyTrustedUrls to "将受信任的URL复制到剪贴板。",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "关于Mehr Guard",
    WebStringKey.OpenSourceLicenses to "开源许可证",
    WebStringKey.PrivacyPolicy to "隐私政策",
    WebStringKey.Acknowledgements to "致谢",
    WebStringKey.ResetAllSettings to "重置所有设置",
    WebStringKey.AddToAllowlist to "添加到允许列表",
    WebStringKey.AddToBlocklist to "添加到阻止列表",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "离线分析。",
    WebStringKey.YourDataStaysOnDevice to "您的数据保留在设备上。",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard在设备上进行安全分析处理每次扫描。我们优先考虑零云遥测的可解释安全性。",
    WebStringKey.OnDeviceAnalysis to "设备上分析",
    WebStringKey.OnDeviceAnalysisDesc to "所有威胁检测都在您的设备上本地运行。没有数据离开您的系统。",
    WebStringKey.NoCloudLogs to "无云日志",
    WebStringKey.NoCloudLogsDesc to "我们严格禁用扫描的传出遥测。结果和哈希保留在本地。",
    WebStringKey.OnDeviceDB to "设备上数据库",
    WebStringKey.OnDeviceDBDesc to "完整的威胁签名数据库下载到您的设备以进行毫秒级查找。",
    WebStringKey.DataLifecycleVerification to "数据生命周期验证",
    WebStringKey.SecurityAuditPass to "安全审核：通过",
    
    // Footer
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc. 保留所有权利。",
    WebStringKey.Support to "支持",
    WebStringKey.Terms to "条款",
    WebStringKey.SystemsOperational to "系统运行正常",
    WebStringKey.SystemSecure to "系统安全",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • 系统安全",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "由Mehr Guard Enterprise验证",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "张伟",
    WebStringKey.SampleUserRole to "安全分析师",
    
    // Export Preview
    WebStringKey.DetailLabel to "详情标签",
    WebStringKey.DetailValue to "详情值",
    WebStringKey.Suspicious to "可疑",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "错误的决定",
    WebStringKey.WrongAnswer to "哎呀！那不对。",
    WebStringKey.ResponseTime to "响应时间",
    WebStringKey.IncomingMessage to "收到的消息",
    WebStringKey.CertificateIssuer to "证书颁发者与域所有者匹配",
    WebStringKey.DomainAgeTrust to "域名年龄 > 5年（高信任）",
    WebStringKey.WhitelistedRank to "本地白名单中的Alexa前1k",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "教育笔记",
    WebStringKey.GameHintTitle to "游戏提示",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "添加到允许列表",
    WebStringKey.AddToBlocklistTitle to "添加到阻止列表",
    WebStringKey.EnterDomainPrompt to "输入要添加到列表的域名",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "延迟",
    WebStringKey.StreakFire to "连胜",
    WebStringKey.AccuracyPercent to "准确度",
    WebStringKey.ConfidencePercent to "置信度",
    
    // Languages
    WebStringKey.English to "英语",
    WebStringKey.German to "德语",
    WebStringKey.Spanish to "西班牙语",
    WebStringKey.French to "法语",
    WebStringKey.ChineseSimplified to "简体中文",
    WebStringKey.Japanese to "日语",
    WebStringKey.Hindi to "印地语",
    WebStringKey.Arabic to "阿拉伯语",
    WebStringKey.Indonesian to "印尼语",
    WebStringKey.Italian to "意大利语",
    WebStringKey.Korean to "韩语",
    WebStringKey.Portuguese to "葡萄牙语",
    WebStringKey.Russian to "俄语",
    WebStringKey.Thai to "泰语",
    WebStringKey.Turkish to "土耳其语",
    WebStringKey.Vietnamese to "越南语"
,
    WebStringKey.ComponentVoting to "组件投票",
    WebStringKey.Heuristic to "启发式",
    WebStringKey.MLModel to "ML模型",
    WebStringKey.Brand to "品牌",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "多数投票决定判定: 3+安全=绿色, 2+恶意=红色"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "等待扫描...",
    WebStringKey.WaitingForAnalysis to "等待分析...",
    WebStringKey.ScanURLToSeeResults to "扫描URL以查看详细结果。",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "关于 Mehr Guard Security",
    WebStringKey.ActualDomain to "实际域名",
    WebStringKey.AnalysisComplete to "分析完成",
    WebStringKey.AutoBlockThreatsDesc to "自动阻止威胁",
    WebStringKey.AwaitingScanLabel to "等待扫描",
    WebStringKey.BrandImpersonation to "品牌假冒",
    WebStringKey.CautionAdvised to "建议谨慎",
    WebStringKey.CompactViewDesc to "紧凑视图",
    WebStringKey.DoNotVisit to "请勿访问",
    WebStringKey.DoNotVisitDesc to "检测到高可信度钓鱼。此URL显示多个恶意指标。",
    WebStringKey.DomainUsesInternationalChars to "此域名使用可能模仿合法域名的国际字符。",
    WebStringKey.GoToScanner to "前往扫描器",
    WebStringKey.Hebrew to "希伯来语",
    WebStringKey.HelpKeyboardShortcuts to "键盘快捷键",
    WebStringKey.HeuristicAnalysis to "启发式分析",
    WebStringKey.HeuristicAnalysisDesc to "URL根据分析引擎检测到的多个风险因素被标记。",
    WebStringKey.HiddenDestination to "隐藏目标",
    WebStringKey.HighRisk to "高风险",
    WebStringKey.HighRiskLabel to "高风险",
    WebStringKey.HomographIdnAttack to "同形字 / IDN 攻击",
    WebStringKey.InternationalizedDomainDetected to "检测到国际化域名。",
    WebStringKey.JustNow to "刚刚",
    WebStringKey.KeyboardShortcutsDesc to "快速访问的键盘快捷键",
    WebStringKey.LiveFeedActive to "实时订阅已激活",
    WebStringKey.LowRisk to "低风险",
    WebStringKey.LowRiskLabel to "低风险",
    WebStringKey.Malicious to "恶意",
    WebStringKey.MediumRiskLabel to "中等风险",
    WebStringKey.NoData to "无数据",
    WebStringKey.NoScanDataResults to "没有扫描数据。请扫描URL以查看分析结果。",
    WebStringKey.NoUrlScanned to "未扫描URL",
    WebStringKey.Persian to "波斯语",
    WebStringKey.PhishingIndicators to "钓鱼指标",
    WebStringKey.ProceedWithCaution to "请谨慎操作",
    WebStringKey.ProceedWithCautionDesc to "检测到一些可疑指标。在输入敏感信息之前请验证来源。",
    WebStringKey.RealTimeScanningDesc to "实时扫描",
    WebStringKey.RedirectShortenerDetected to "检测到重定向/缩短",
    WebStringKey.SafeToVisit to "访问安全",
    WebStringKey.SafeToVisitDesc to "已通过本地启发式v2.4验证。未发现钓鱼模式、混淆脚本或黑名单匹配。",
    WebStringKey.SafetyScore to "安全评分",
    WebStringKey.ScanCompleteLabel to "扫描完成",
    WebStringKey.ScanToAnalyze to "扫描二维码或输入URL进行分析。",
    WebStringKey.ScannedURLLabel to "已扫描的URL",
    WebStringKey.SecuritySignal to "安全信号",
    WebStringKey.SensitivityLevelDesc to "灵敏度级别",
    WebStringKey.SensitivityPermissive to "宽容",
    WebStringKey.SensitivityStrict to "严格",
    WebStringKey.SettingsDetection to "检测",
    WebStringKey.SettingsDisplay to "显示",
    WebStringKey.SettingsLanguage to "语言",
    WebStringKey.SettingsLanguageDesc to "选择界面语言",
    WebStringKey.SettingsNotifications to "通知",
    WebStringKey.SettingsSavedAutomatically to "设置会自动保存并在会话之间同步。",
    WebStringKey.ShowConfidenceScoreDesc to "显示置信度分数",
    WebStringKey.SoundAlertsDesc to "声音警报",
    WebStringKey.SuspiciousDomain to "可疑域名",
    WebStringKey.SuspiciousEncoding to "可疑编码",
    WebStringKey.SuspiciousKeywords to "可疑关键词",
    WebStringKey.SuspiciousTld to "可疑TLD",
    WebStringKey.SuspiciousTldDesc to "域名使用通常与恶意网站相关的{tld} TLD。",
    WebStringKey.SuspiciousUrlParams to "可疑URL参数",
    WebStringKey.SuspiciousUrlParamsDesc to "URL包含复杂或可能混淆的参数。",
    WebStringKey.ThreatAlertsDesc to "威胁警报",
    WebStringKey.ThreatDetected to "检测到威胁",
    WebStringKey.UnableToDetermine to "无法确定结论。请重试。",
    WebStringKey.Unknown to "未知",
    WebStringKey.UnknownURL to "未知URL",
    WebStringKey.UrlShortenerDesc to "URL使用隐藏最终目标的缩短服务。",
    WebStringKey.UrlShortenerDetected to "检测到URL缩短",
    WebStringKey.VersionOfflineReady to "离线就绪",
    WebStringKey.VisualAppearance to "视觉外观",
    WebStringKey.WaitingForAnalysisLabel to "等待分析..."
)

internal val ChineseCommonStrings = mapOf(
    "\"Always expand short links before scanning. The bot does this automatically by following redirect headers without rendering the page.\"" to "“扫描前务必展开短链接。机器人会通过跟随重定向标头自动执行此操作，而不渲染页面。”",
    "\"AusPost: Your parcel failed delivery due to incorrect address details. Please update immediately via the link above to avoid return.\"" to "“AusPost：由于地址详细信息不正确，您的包裹投递失败。请立即通过上面的链接更新，以避免退货。”",
    "\"Commonwealth Bank: Your account has been locked due to suspicious activity. Verify your identity immediately.\"" to "“联邦银行：您的帐户因可疑活动已被锁定。立即验证您的身份。”",
    "\"Let's Encrypt (R3)\"" to "“Let's Encrypt (R3)“",
    "\"Phishing\"" to "“网络钓鱼”",
    "\"You won a \$500 gift card! Click to claim your prize.\"" to "“您赢得了 500 美元的礼品卡！点击领取奖品。”",
    "\"Your Apple ID was used to sign in on a new device. If this was not you, verify immediately.\"" to "“您的 Apple ID 已被用于在新设备上登录。如果这不是您本人，请立即验证。”",
    "\"Your PayPal account has been limited. Please update your information.\"" to "“您的 PayPal 帐户已受到限制。”",
    "+10-15 points — Context-dependent signal" to "+10-15 分 —上下文相关信号",
    "+10-15 points — Suggestive but not conclusive" to "+10-15 分 — 暗示性但非决定性",
    "+10-15 points — Suspicious but not definitive" to "+10-15 分 — 可疑但不确定",
    "+10-20 points — Contributes to overall risk score" to "+10-20 分 — 有助于总体风险评分",
    "+15-20 points — Requires caution, not definitive" to "+15-20 分 — 需要谨慎，而非确定性",
    "+15-20 points — Requires destination inspection" to "+15-20 分 — 需要目的地检查",
    "+15-20 points — Security baseline not met" to "+15-20 分 — 未达到安全基线",
    "+20-30 points — Deliberate deception technique" to "+20-30 分 — 故意欺骗技术",
    "+20-30 points — Legitimate brands rarely use these" to "+20-30 分 — 合法品牌很少使用这些",
    "+25-30 points — Strong phishing indicator" to "+25-30 分 — 强大的网络钓鱼指标",
    "+30-35 points — Requires investigation of actual characters" to "+30-35 分 — 需要调查实际情况字符",
    "+30-40 points — This is a primary phishing indicator" to "+30-40 点 — 这是主要网络钓鱼指示器",
    "+40-50 points — Advanced attack requiring intentional deception" to "+40-50 点 — 需要故意欺骗的高级攻击",
    "+5-10 points — Minor signal" to "+5-10 点 — 次要信号",
    "- Heuristics: {list}" to "- 启发式：{list}",
    "- Redirects: {count}" to "- 重定向：{count}",
    "- SSL Issuer: {issuer}" to "- SSL 颁发者： {issuer}",
    "- Threat Type: {type}" to "- 威胁类型：{type}",
    "1 hr ago • Phishing" to "1 小时前 • 网络钓鱼",
    "100% offline" to "100% 离线",
    "2 hours ago" to "2 小时前",
    "2 mins ago • Safe" to "2 分钟前 • 安全",
    "25+ AI Heuristics" to "25+ AI 启发式",
    "3 hops detected involving known URL shorteners." to "检测到涉及已知 URL 的 3 跳",
    "3 hrs ago • Safe" to "3 小时前 • 安全",
    "350 pts" to "350 点",
    "400 pts" to "400 点",
    "5 hrs ago • Safe" to "5 小时前 • 安全",
    "< 24 hours" to "< 24 小时",
    "A phishing attempt was successfully blocked" to "网络钓鱼尝试已成功阻止",
    "A shorter, cleaner URL would reduce this signal contribution by ~8 points." to "更短、更干净的 URL 会将此信号贡献减少约 8点。",
    "AD" to "AD",
    "AI-powered phishing detection running 100% offline in your browser." to "由 AI 驱动的网络钓鱼检测在浏览器中 100% 离线运行。",
    "AI-powered phishing detection that runs" to "由 AI 驱动的网络钓鱼检测运行",
    "AM" to "AM",
    "About Mehr Guard" to "关于[[品牌]]",
    "Accuracy" to "准确度",
    "Accuracy:" to "准确度：",
    "Acknowledgements" to "致谢",
    "Active" to "主动",
    "Active Protection" to "主动保护",
    "Active Scanner" to "主动扫描",
    "Actual Punycode (Where it goes)" to "实际Punycode（去向）",
    "Add Domain" to "添加域",
    "Add manually" to "添加手动",
    "Add to Allowlist" to "添加到允许列表",
    "Add to Blocklist" to "添加到阻止列表",
    "Added 1 week ago" to "1 周前添加",
    "Added 2 days ago" to "2 天前添加",
    "Added {domain} to {list}" to "将 {domain} 添加到 {list}",
    "Adjust heuristic thresholds. Higher sensitivity may increase false positives." to "调整启发式阈值。较高的灵敏度可能会增加误报。",
    "Alex Chen" to "Alex Chen",
    "Alex Morgan" to "Alex Morgan",
    "Alexa Top 1000 site" to "Alexa Top 1000 站点",
    "All URLs will show as MALICIOUS for demo purposes" to "出于演示目的，所有 URL 将显示为恶意",
    "All code execution happens in an ephemeral container that is destroyed after each scan. This ensures malicious payloads can never escape to your system." to "所有代码执行都发生在每次扫描后都会被销毁的临时容器中。这可确保恶意负载永远不会逃逸到您的系统。",
    "All notifications marked as read" to "标记为已读的所有通知",
    "Allow List" to "允许列表",
    "Allowlist" to "允许列表",
    "Analysed offline." to "离线分析。",
    "Analysis" to "分析",
    "Analysis Complete" to "分析完成",
    "Analysis Engine Loading..." to "分析引擎正在加载...",
    "Analysis Summary" to "分析摘要",
    "Analysis Time" to "分析时间",
    "Analyze" to "分析",
    "Analyze This URL" to "分析此 URL",
    "Analyze URL" to "分析 URL",
    "Analyzed offline in <5ms" to "在 <5 毫秒内离线分析",
    "Analyzing offline..." to "正在离线分析...",
    "Anonymous Telemetry" to "匿名遥测",
    "Anonymous Telemetry disabled" to "匿名遥测已禁用",
    "Anonymous Telemetry enabled" to "匿名遥测已启用",
    "Apple Support" to "Apple支持",
    "Apple only uses apple.com for all account-related activities. Be wary of domains containing brand names but with different extensions." to "Apple 仅使用 apple.com 进行所有与帐户相关的活动。请警惕包含品牌名称但具有不同扩展名的域名。",
    "Apple would never use a third-party domain for account verification. Check the actual domain name." to "Apple 绝不会使用第三方域名进行帐户验证。检查实际域名。",
    "Are you sure you want to end this session? Progress will be lost." to "您确定要结束本次会话吗？进展将会丢失。",
    "Atlassian" to "Atlassian",
    "Atlassian is a legitimate software company. Their primary domain atlassian.com is trustworthy." to "Atlassian 是一家合法的软件公司。他们的主域 atlassian.com 值得信赖。",
    "Attack Breakdown" to "攻击分解",
    "Attackers create domains that look like trusted brands to steal credentials" to "攻击者创建看似受信任品牌的域来窃取凭据",
    "Auto-Block Threats" to "自动阻止威胁",
    "Auto-Copy Safe Links" to "自动复制安全链接",
    "Auto-Copy Safe Links disabled" to "自动复制安全链接已禁用",
    "Auto-Copy Safe Links enabled" to "自动复制安全链接已启用",
    "Automatically block high-risk URLs" to "自动阻止高风险URL",
    "Back online" to "返回在线",
    "Back to Dashboard" to "返回仪表板",
    "Balanced" to "平衡",
    "Balanced Mode (Recommended)" to "平衡模式（推荐）",
    "Beat the Bot" to "击败机器人",
    "Beat the Bot →" to "击败机器人→",
    "Best Streak" to "最佳连胜",
    "Blacklist Match" to "黑名单匹配",
    "Blacklist Status" to "黑名单状态",
    "Block & Report" to "阻止并报告",
    "Blocklist" to "阻止列表",
    "Bot Score" to "机器人分数",
    "Brand Impersonation" to "品牌假冒",
    "Brand Impersonation Detected" to "品牌假冒检测到",
    "Brands Detected" to "检测到品牌",
    "Browser Preview" to "浏览器预览",
    "Built for" to "专为",
    "CLEAN" to "清洁",
    "CRITICAL" to "关键",
    "Camera API (QR scanning unavailable)" to "相机API（QR扫描不可用）",
    "Camera Access Required" to "需要相机访问",
    "Camera Not Available" to "相机不可用",
    "Camera activated" to "相机已激活",
    "Camera error: {error}" to "相机错误：{error}",
    "Camera not supported in this browser" to "此浏览器不支持相机",
    "Camera permission denied" to "相机权限被拒绝",
    "Can redirect through tracking or to malicious destinations" to "可以通过跟踪重定向或重定向到恶意目的地",
    "Cancel" to "取消",
    "Caution" to "警告",
    "Caution Advised" to "建议警告",
    "Certificate Issuer matches domain owner (DigiCert Inc)" to "证书颁发者与域所有者匹配(DigiCert Inc)",
    "Certificate Issuer matches domain owner (DigiCert Inc)." to "证书颁发者与域所有者 (DigiCert Inc) 匹配。",
    "Certificate issued by DigiCert Inc. No anomalies in chain of trust." to "由 DigiCert Inc 颁发的证书。信任链中没有异常。",
    "Certificate issued by trusted CA. No anomalies in chain of trust." to "由受信任的 CA 颁发的证书。信任链中没有异常。",
    "Certificate recently issued or self-signed. Proceed with caution." to "最近颁发或自签名的证书。谨慎行事。",
    "Challenge our offline AI engine. Can you spot the phish faster?" to "挑战我们的离线人工智能引擎。您能更快地发现网络钓鱼吗？",
    "Characters like Cyrillic \"а\" look identical to Latin \"a\" but are different" to "像西里尔字母“а”这样的字符看起来与拉丁语“a”相同，但有所不同",
    "Check for Updates" to "检查更新",
    "Check the domain carefully. This appears to be a well-known, trusted domain." to "仔细检查域。这似乎是一个众所周知的受信任域。",
    "Choose Format" to "选择格式",
    "Clear All" to "全部清除",
    "Clear History" to "清除历史记录",
    "Clear scan history?" to "清除扫描历史记录？",
    "Click a sample below or paste any URL:" to "单击下面的示例或粘贴任何 URL：",
    "Close" to "关闭",
    "Code execution happens in an ephemeral container. Malicious payloads never touch your OS kernel." to "代码执行发生在临时容器中。恶意负载永远不会触及您的操作系统内核。",
    "Combined with other signals, suggests intent to steal credentials" to "与其他信号结合，表明意图窃取凭据",
    "Compact View" to "紧凑视图",
    "Compact view" to "紧凑视图",
    "Complete analysis is performed locally. Your camera feed and scanned data never touch an external server, ensuring absolute privacy." to "在本地执行完整分析。您的摄像头馈送和扫描数据永远不会接触外部服务器，从而确保绝对隐私。",
    "Confidence Score" to "置信度得分",
    "Confidence score" to "置信度得分",
    "Confidence: 99.8%" to "置信度：99.8%",
    "Configure formats and download your threat analysis." to "配置格式并下载威胁分析。",
    "Congratulations! You beat the bot!" to "恭喜！您击败了机器人！",
    "Continue Anyway" to "无论如何继续",
    "Copy" to "复制",
    "Copy Link" to "复制链接",
    "Copy trusted URLs to clipboard." to "将受信任的 URL 复制到剪贴板。",
    "Core v2.4.1 • Build 2024.12.19" to "Core v2.4.1 • 版本 2024.12.19",
    "Correct Decision!" to "正确的决定！",
    "Correct!" to "正确！",
    "Could not save theme preference:" to "可以不保存主题首选项：",
    "Couldn\\'t Read QR Code" to "无法读取 QR 码",
    "Credential Harvesting Path" to "凭据获取路径",
    "Credential Harvesting Path (/login)" to "凭据获取路径 (/login)",
    "Current" to "当前",
    "Cyrillic characters mimicking Latin alphabet detected." to "检测到模仿拉丁字母的西里尔字符。",
    "DB CHECK" to "DB检查",
    "DISCONNECTED" to "已断开连接",
    "DO NOT VISIT" to "请勿访问",
    "DOMAIN" to "域",
    "Dangerous" to "危险",
    "Dark" to "黑暗",
    "Dashboard" to "仪表板",
    "Data Lifecycle Verification" to "数据生命周期验证",
    "Data Point" to "数据点",
    "Data exported successfully!" to "数据已成功导出！",
    "Data sent without encryption can be intercepted" to "未加密发送的数据可以被拦截",
    "Database Updated" to "数据库更新",
    "Decoded URL/Payload" to "解码的URL/有效负载",
    "Deep subdomains can hide the actual domain at the end" to "深层子域可以隐藏末尾的实际域",
    "Destination URL obfuscated. Unable to verify final target." to "混淆的目标URL。无法验证最终目标。",
    "Details" to "详细信息",
    "Detection" to "检测",
    "Deutsch" to "Deutsch",
    "Disable all external link previews." to "禁用所有外部链接预览。",
    "Display" to "显示",
    "Display threat probability percentage" to "显示威胁概率百分比",
    "Do Not Visit This URL" to "请勿访问此 URL",
    "Domain \"apple-id-verify.com\" is not owned by Apple" to "域“apple-id-verify.com”不属于Apple",
    "Domain age > 5 years (High trust)." to "域名年龄 > 5 年（高信任）。",
    "Domain age is less than 24 hours." to "域名年龄小于 24 小时。",
    "Domain already in list" to "域名已在列表中",
    "Domain contains \"xn--\" IDN encoding" to "域名包含“xn--”IDN 编码",
    "Domain contains or mimics a known brand name (PayPal, Amazon, etc.)" to "域名包含或模仿已知品牌名称（PayPal、Amazon 等）",
    "Domain mimics known brand (PayPal → Paypa1). High-confidence phishing." to "域名模仿已知品牌（PayPal →支付宝1）。高可信度网络钓鱼。",
    "Domain mimics legitimate bank (commbank.com.au)" to "域名模仿合法银行 (commbank.com.au)",
    "Domain or path contains random-looking character sequences" to "域名或路径包含看似随机的字符序列",
    "Domain registered > 5 years ago. Low probability of churn-and-burn." to "域名注册时间超过 5 年。流失和烧毁的可能性很低。",
    "Domain registered in the last 24 hours" to "在过去 24 小时内注册的域名",
    "Domain uses common misspellings or character substitutions (paypa1, amaz0n)" to "域名使用常见的拼写错误或字符替换（paypa1、amaz0n）",
    "Domain uses suspicious hyphenated structure (verify-deliveries.net)" to "域名使用可疑的连字符结构 (verify-deliveries.net)",
    "Don't just get a \"Block\". We provide detailed heuristic breakdowns of URL parameters, redirects, and javascript payloads." to "不要只是得到“阻止”。我们提供 URL 参数、重定向和 JavaScript 有效负载的详细启发式细分。",
    "Download Apps" to "下载应用程序",
    "Drag & Drop QR code image here" to "将 QR 代码图像拖放到此处",
    "Drag & drop a QR code image here or enable camera access to start scanning." to "将 QR 代码图像拖放到此处或启用相机访问以开始扫描。",
    "Educational Note" to "教育说明",
    "Embedded Redirect" to "嵌入式重定向",
    "Enable Camera" to "启用相机",
    "Enable camera first" to "首先启用相机",
    "End Session" to "结束会议",
    "Engine" to "引擎",
    "Engine Active" to "发动机启动",
    "Engine Active (Offline)" to "引擎激活（离线）",
    "Engine initializing, please wait..." to "引擎正在初始化，请稍候...",
    "Engine initializing..." to "发动机正在初始化...",
    "Engine not ready, using demo mode" to "引擎未准备好，使用演示模式",
    "English" to "英语",
    "Enter" to "进入",
    "Enter URL" to "输入网址",
    "Enter URL Manually" to "手动输入网址",
    "Enterprise Plan" to "企业计划",
    "Enterprise Protection Active" to "企业防护主动",
    "Esc" to "Esc键",
    "Escape" to "逃脱",
    "Español" to "西班牙语",
    "Established Domain" to "已建立域名",
    "Excessive Subdomains" to "子域名过多",
    "Excessively Long URL" to "网址过长",
    "Exit" to "出口",
    "Explainable Defence." to "可解释的防御。",
    "Explainable Security" to "可解释的安全性",
    "Export" to "出口",
    "Export Report" to "出口报告",
    "Export Reports" to "导出报告",
    "Exports include all identified threat vectors, headers, and the raw payload analysis." to "导出包括所有已识别的威胁向量、标头和原始有效负载分析。",
    "External Transmission" to "外部传输",
    "FAIL" to "失败",
    "Failed to copy link" to "复制链接失败",
    "Failed to copy report" to "复制报告失败",
    "Failed to get scan statistics:" to "无法获取扫描统计信息：",
    "Failed to load image" to "加载图像失败",
    "Failed to read file" to "读取文件失败",
    "Failed to share" to "分享失败",
    "Failed to share report" to "分享报告失败",
    "File upload (image scanning unavailable)" to "文件上传（不支持图片扫描）",
    "Final Destination" to "最终目的地",
    "Final Results" to "最终结果",
    "Fix it" to "修复它",
    "For the best experience, use Chrome, Firefox, Safari, or Edge." to "为了获得最佳体验，请使用 Chrome、Firefox、Safari 或 Edge。",
    "Found in 3 local offline threat databases." to "在 3 个本地离线威胁数据库中发现。",
    "Français" to "法国人",
    "Free/cheap TLDs are heavily abused for throwaway phishing domains" to "免费/廉价 TLD 被严重滥用于一次性网络钓鱼域名",
    "Gallery" to "画廊",
    "Game Over!" to "游戏结束！",
    "Generate Test QR" to "生成测试二维码",
    "Generate a test malicious QR code" to "生成测试恶意二维码",
    "Generated on Dec 29, 2025 • 14:32:01 UTC" to "生成于 2025 年 12 月 29 日 • 14:32:01 UTC",
    "Generated on {date} • {time} UTC" to "生成于 {date} • {time} UTC",
    "Generating {format} report..." to "正在生成 {format} 报告...",
    "Get Started! 🚀" to "开始吧！ 🚀",
    "GitHub" to "GitHub",
    "GitHub.com is a legitimate developer platform owned by Microsoft. Always verify the exact domain spelling." to "GitHub.com 是 Microsoft 拥有的合法开发者平台。始终验证域的准确拼写。",
    "Gmail" to "邮箱",
    "Google Docs" to "谷歌文档",
    "Google Docs uses docs.google.com. Always verify the sender knows you before opening shared documents." to "Google 文档使用 docs.google.com。在打开共享文档之前，请务必确认发件人认识您。",
    "Google services use subdomains of google.com. mail.google.com is the legitimate Gmail address." to "Google 服务使用 google.com 的子域。 mail.google.com 是合法的 Gmail 地址。",
    "Got it" to "知道了",
    "HIGH" to "高的",
    "HIGH RISK" to "高风险",
    "HIGH RISK DETECTED" to "检测到高风险",
    "HTTP instead of HTTPS (no encryption)" to "HTTP 代替 HTTPS（无加密）",
    "HTTPS" to "HTTPS",
    "Help" to "帮助",
    "Heuristic Engine" to "启发式引擎",
    "Heuristics" to "启发式",
    "Hides the true destination URL from the user" to "对用户隐藏真实的目标 URL",
    "High" to "高的",
    "High Entropy" to "高熵",
    "High Risk" to "高风险",
    "High entropy string detected in URL parameters." to "在 URL 参数中检测到高熵字符串。",
    "High-Performance Engine" to "高性能发动机",
    "High-Risk TLD" to "高风险顶级域名",
    "High-Risk URL Blocked" to "高风险 URL 被阻止",
    "High-confidence phishing detected. This URL exhibits multiple malicious indicators." to "检测到高可信度网络钓鱼。此 URL 表现出多个恶意指标。",
    "Hold steady. Analysed offline in <5ms." to "保持稳定。在 <5 毫秒内离线分析。",
    "Home" to "家",
    "Homograph / IDN Attack" to "同形异义词/IDN 攻击",
    "Homograph Attack" to "同形异义词攻击",
    "Homograph attack: \"c0mmonwealth\" uses zero instead of letter O" to "同形异义词攻击：“c0mmonwealth”使用零而不是字母 O",
    "Homograph attack: \"paypa1\" uses number 1 instead of letter L" to "同形异义词攻击：“paypa1”使用数字 1 而不是字母 L",
    "Homograph attacks use similar-looking characters. Always check URLs character by character for suspicious substitutions." to "同形异义词攻击使用外观相似的字符。始终逐个字符检查 URL 是否存在可疑替换。",
    "How aggressive should threat detection be?" to "威胁检测应该有多积极？",
    "Human-Readable Report" to "人类可读的报告",
    "I am reporting a suspected phishing URL detected by Mehr Guard:" to "我正在报告 Mehr Guard 检测到的可疑网络钓鱼 URL：",
    "ID: scan_2025_12_29_h9t2" to "编号：scan_2025_12_29_h9t2",
    "ID: {id}" to "ID：{id}",
    "INFO" to "信息",
    "IP Address Host" to "IP地址主机",
    "If HTTPS was used, this signal would not trigger and score would drop by ~18 points." to "如果使用 HTTPS，则不会触发该信号，分数将下降约 18 分。",
    "If a registered domain name was used instead of IP address, score would drop by ~28 points." to "如果使用注册域名代替 IP 地址，分数将下降约 28 分。",
    "If all characters were ASCII Latin letters, this signal would not trigger and score would drop by ~45 points." to "如果所有字符都是 ASCII 拉丁字母，则该信号将不会触发，分数将下降约 45 分。",
    "If no embedded URLs were present in query parameters, score would drop by ~18 points." to "如果查询参数中不存在嵌入的 URL，得分将下降约 18 分。",
    "If only 1-2 subdomains were used, this signal would not trigger. Score would drop by ~12 points." to "如果只使用1-2个子域，则不会触发该信号。分数将下降约 12 分。",
    "If the domain spelled the brand correctly without substitutions, score would drop by ~25 points." to "如果域名在没有替换的情况下正确拼写了品牌，得分将下降约 25 分。",
    "If the domain used only ASCII characters (no IDN), score would drop by ~32 points." to "如果域仅使用 ASCII 字符（无 IDN），分数将下降约 32 分。",
    "If the domain used readable words instead of random characters, score would drop by ~12 points." to "如果该域使用可读单词而不是随机字符，则分数将下降约 12 分。",
    "If the full destination URL was visible, score would drop by ~18 points (assuming destination is safe)." to "如果完整的目标 URL 可见，得分将下降约 18 分（假设目标是安全的）。",
    "If this URL used .com, .org, or country TLDs, score would drop by ~25 points." to "如果此 URL 使用 .com、.org 或国家/地区 TLD，得分将下降约 25 分。",
    "If this were the official brand domain (paypal.com), this signal would not trigger and score would drop by ~35 points." to "如果这是官方品牌域 (paypal.com)，则不会触发此信号，分数将下降约 35 分。",
    "Import Image" to "导入图像",
    "Imported: {name}" to "导入：{name}",
    "Incoming Message (+61 491 570 010):" to "传入消息 (+61 491 570 010)：",
    "Incorrect Decision" to "错误决策",
    "Intermediate Hop" to "中间跳跃",
    "International domains can hide malicious lookalike characters" to "国际域可以隐藏恶意相似字符",
    "Invalid URL Format" to "无效的 URL 格式",
    "Invalid URL format" to "无效的 URL 格式",
    "Invalid theme:" to "无效的主题：",
    "Isolated Sandbox" to "隔离沙箱",
    "It's a Tie!" to "这是平局！",
    "JS" to "JS",
    "JSON format. Best for SIEM integration." to "JSON 格式。最适合 SIEM 集成。",
    "JSON report downloaded" to "下载 JSON 报告",
    "John Smith" to "John Smith",
    "Judge Mode" to "判断模式",
    "Judge Mode Active" to "判断模式处于活动状态",
    "Judge Mode OFF - Normal detection active" to "判断模式关闭 - 正常检测处于活动状态",
    "Judge Mode: Force MALICIOUS results for demo" to "判断模式：强制为演示提供恶意结果",
    "Judge Mode: ON" to "判断模式：打开",
    "Just now" to "仅现在",
    "Kotlin Multiplatform" to "Kotlin 多平台",
    "Kotlin engine not ready yet" to "Kotlin 引擎尚未准备好",
    "Kotlin/Wasm" to "Kotlin/Wasm",
    "KotlinConf Student Competition 2025-2026" to "KotlinConf 学生竞赛 2025-2026",
    "LIVE" to "直播",
    "LIVE FEED ACTIVE" to "实时反馈活跃",
    "LIVE FEED DISCONNECTED" to "实时反馈已断开连接",
    "LOW" to "低",
    "LOW RISK" to "低风险",
    "Language: {language} {flag}" to "语言：{language} {flag}",
    "Last Update" to "上次更新",
    "Latency" to "延迟",
    "Latency: 2ms" to "延迟：2ms",
    "Learn about our local architecture" to "了解我们的本地架构",
    "Learn how to identify advanced QR homograph attacks." to "了解如何识别高级 QR 同形异义词攻击。",
    "Legitimate" to "合法",
    "Legitimate services use domains; IPs hide identity and bypass filters" to "合法服务使用域； IP 隐藏身份并绕过过滤器",
    "Let's Encrypt (R3)" to "Let's Encrypt (R3)",
    "Light" to "Light",
    "Limited Browser Support" to "有限浏览器支持",
    "Link copied to clipboard!" to "链接已复制到剪贴板！",
    "LinkedIn" to "LinkedIn",
    "LinkedIn uses linkedin.com as their primary domain. Profile URLs follow the /in/username format." to "LinkedIn 使用 linkedin.com 作为其主域。配置文件 URL 遵循 /in/用户名格式。",
    "Live Hint" to "实时提示",
    "Live Preview" to "实时预览",
    "Live Scanner" to "实时扫描仪",
    "Live Scoreboard" to "实时记分板",
    "Local DB" to "本地数据库",
    "Local Database" to "本地数据库",
    "Local Memory (RAM)" to "本地内存 (RAM)",
    "Local Privacy" to "本地隐私",
    "Local Sandbox" to "本地沙箱",
    "Local database v2.4.1 active. No data leaves this device." to "本地数据库 v2.4.1 已激活。没有数据离开此设备。",
    "Local storage (history won\\'t persist)" to "本地存储（历史记录不会保留）",
    "Long URLs can hide malicious parameters or overwhelm users" to "长 URL 可能隐藏恶意参数或淹没用户",
    "Look at the domain carefully. Is \"c0mmonwealth\" spelled correctly? The number 0 is often used to replace the letter O." to "仔细查看域。 “c0mmonwealth”拼写正确吗？数字0经常用来代替字母O。",
    "Look at the domain name carefully. Is \"paypa1\" spelled correctly?" to "仔细看看域名。 “paypa1”拼写正确吗？",
    "Look closely at the domain structure. Legitimate organisations rarely use hyphens in the main domain name or generic TLDs like" to "仔细查看域结构。合法组织很少在主域名或通用 TLD 中使用连字符，例如",
    "Low" to "低",
    "Low Risk" to "低风险",
    "Low Sensitivity Mode" to "低敏感度模式",
    "MALICIOUS" to "恶意",
    "MEDIUM" to "中",
    "MEDIUM RISK" to "中风险",
    "MINOR CONCERNS" to "轻微问题",
    "Machine-Readable" to "机器可读",
    "Make your decision" to "做出决定",
    "Malicious" to "恶意",
    "Manage privacy controls, sensitivity, and security lists." to "管理隐私控制、敏感度和安全列表。",
    "Matched 3 signatures in local phishing DB." to "在本地网络钓鱼数据库中匹配了 3 个签名。",
    "Maximum protection. Blocks any suspicious patterns including newly registered domains, uncommon TLDs, and any URL with potential encoding tricks." to "最大程度的保护。阻止任何可疑模式，包括新注册的域、不常见的 TLD 以及任何具有潜在编码技巧的 URL。",
    "Medium" to "中",
    "Microsoft-owned platform" to "Microsoft 拥有的平台",
    "Missing features:" to "缺少功能：",
    "More than 3 subdomain levels (secure.login.paypal.fake.com)" to "超过 3 个子域级别 (secure.login.paypal.fake.com)",
    "Need help? Visit our GitHub for documentation" to "需要帮助？请访问我们的 GitHub 获取文档",
    "Never trust shortened URLs from unknown sources. Use URL expander tools to see the real destination before clicking." to "永远不要相信来自未知来源的缩短 URL。单击之前，请使用 URL 扩展工具查看真正的目的地。",
    "Newly Registered Domain" to "新注册的域",
    "Next Round" to "下一轮",
    "Next →" to "下一个→",
    "No Cloud Logs" to "无云日志",
    "No HTTPS Encryption" to "无 HTTPS 加密",
    "No HTTPS encryption" to "无 HTTPS 加密",
    "No QR code found in image" to "图像中未找到二维码",
    "No URL to copy" to "无 URL复制",
    "No URL to open" to "没有可打开的 URL",
    "No URL to report - analyze one first" to "没有可报告的 URL - 首先分析一个",
    "No camera found" to "未找到摄像头",
    "No custom domains blocked." to "没有阻止自定义域。",
    "No data leaves device" to "没有数据离开设备",
    "No new notifications" to "没有新通知",
    "No recent analysis to view" to "没有可查看的最新分析",
    "No recent scans" to "没有最近的扫描",
    "No security threats were detected. The QR code leads to a verified safe destination." to "未检测到安全威胁。二维码指向经过验证的安全目的地。",
    "No threats detected" to "未检测到威胁",
    "None" to "无",
    "Not a valid URL" to "不是有效的 URL",
    "Not found in 52 local offline threat databases." to "在 52 个本地离线威胁数据库中未找到。",
    "Not the official PayPal domain (paypal.com)" to "不是 PayPal 官方域 (paypal.com)",
    "Notifications" to "通知",
    "Obfuscated JavaScript" to "已模糊处理JavaScript",
    "Obfuscated Script" to "模糊脚本",
    "Official LinkedIn domain" to "LinkedIn 官方域",
    "Official postal services use their primary domain (auspost.com.au) for all tracking. Verify by visiting the official website directly." to "官方邮政服务使用其主域 (auspost.com.au) 进行所有跟踪。直接访问官网验证。",
    "Offline" to "离线",
    "Offline Core v2.4" to "离线Core v2.4",
    "Offline Engine V.2.4" to "离线引擎V.2.4",
    "Offline Guarantee:" to "离线保障：",
    "Offline Mode" to "离线模式",
    "Offline Mode Active" to "离线模式激活",
    "Offline Privacy" to "离线隐私",
    "Offline Protection" to "离线保护",
    "Offline Ready" to "离线就绪",
    "Offline Security" to "离线安全",
    "Offline-First Architecture" to "离线优先架构",
    "On-Device DB" to "设备上数据库",
    "On-Device Database" to "设备上的数据库",
    "Onboarding" to "入职",
    "Only blocks known malicious URLs from the threat database. Minimal false positives, but may miss novel attacks." to "仅阻止威胁数据库中的已知恶意 URL。误报率极低，但可能会错过新的攻击。",
    "Open Safely (Sandbox)" to "安全打开（沙箱）",
    "Open Source Licenses" to "开源许可证",
    "Opening PhishTank..." to "打开网络钓鱼坦克...",
    "Opening URL in new tab" to "在新选项卡中打开 URL",
    "Opening email client..." to "打开电子邮件客户端...",
    "Optimised for desktop environments. Scans are processed in under 5ms using native Kotlin Multiplatform binaries." to "针对桌面环境进行了优化。使用本机 Kotlin 多平台二进制文件可在 5 毫秒内处理扫描。",
    "Overview" to "概述",
    "PASS" to "经过",
    "PDF format. Best for sharing with stakeholders." to "PDF 格式。最适合与利益相关者共享。",
    "PDF report ready for download" to "PDF 报告可供下载",
    "PHISH" to "网络钓鱼",
    "PHISHING" to "网络钓鱼",
    "PROCEED WITH CAUTION" to "谨慎行事",
    "Paranoia" to "偏执狂",
    "Paranoia Mode" to "偏执模式",
    "Paste URL" to "粘贴网址",
    "Paste URL to Analyze" to "粘贴 URL 进行分析",
    "PayPal Security" to "贝宝安全",
    "Permissive" to "宽容的",
    "Phishing" to "网络钓鱼",
    "Phishing Attempt" to "网络钓鱼尝试",
    "Phishing Detection Sensitivity" to "网络钓鱼检测灵敏度",
    "Phishing Engine" to "网络钓鱼引擎",
    "Phishing Report: {url}" to "网络钓鱼报告：{url}",
    "Phishing detection is running normally" to "网络钓鱼检测正常运行",
    "Play Again" to "再玩一次",
    "Play Now" to "立即播放",
    "Play sound when threat detected" to "检测到威胁时播放声音",
    "Please drop an image file" to "请放下图像文件",
    "Please enter a URL" to "请输入网址",
    "Please enter a domain" to "请输入域名",
    "Please enter a valid domain" to "请输入有效域名",
    "Please select an image" to "请选择图片",
    "Point your camera at a QR code to detect" to "将相机对准二维码即可检测",
    "Points" to "积分",
    "Press Cmd/Ctrl+V again to paste" to "再次按 Cmd/Ctrl+V 进行粘贴",
    "Privacy Controls" to "隐私控制",
    "Privacy Policy" to "隐私政策",
    "Privacy Settings" to "隐私设置",
    "Privacy policy: 100% offline, zero data collection" to "隐私政策：100%离线，零数据收集",
    "Proceed with Caution" to "谨慎行事",
    "Processing Env" to "加工环境",
    "Processing image..." to "处理图像...",
    "Profile" to "轮廓",
    "Profile updated successfully!" to "个人资料更新成功！",
    "Punycode Domain" to "Punycode 域名",
    "QR Code Detected!" to "检测到二维码！",
    "QR Code Scan" to "二维码扫描",
    "QR Code detected!" to "检测到二维码！",
    "Mehr Guard" to "[[品牌]]",
    "Mehr Guard - Beat the Bot" to "[[品牌]] - 击败机器人",
    "Mehr Guard - Dashboard" to "[[品牌]] - 仪表板",
    "Mehr Guard - Offline Privacy Onboarding" to "[[品牌]] - 离线隐私入门",
    "Mehr Guard - Scan Dashboard" to "[[品牌]] - 扫描仪表板",
    "Mehr Guard - Scan Result" to "[[品牌]] - 扫描结果",
    "Mehr Guard - Trust Centre" to "[[品牌]] - 信任中心",
    "Mehr Guard Logo" to "[[品牌]] 标志",
    "Mehr Guard Results" to "[[品牌]] 结果",
    "Mehr Guard Scan Result" to "[[品牌]] 扫描结果",
    "Mehr Guard Security Audit" to "[[品牌]] 安全审核",
    "Mehr Guard Threat Analysis Report" to "[[品牌]] 威胁分析报告",
    "Mehr Guard Threat Report" to "[[品牌]] 威胁报告",
    "Mehr Guard Verdict: {verdict}" to "[[品牌]]判决：{verdict}",
    "Mehr Guard analyses potential threats directly on your hardware. Experience" to "Mehr Guard 直接分析您硬件上的潜在威胁。经验",
    "Mehr Guard explains" to "[[品牌]] 解释",
    "Mehr Guard needs camera access to scan QR codes in real-time." to "Mehr Guard 需要摄像头访问权限才能实时扫描二维码。",
    "Mehr Guard processes every scan within a secure, isolated local sandbox. We prioritize explainable security with zero cloud telemetry for image analysis." to "Mehr Guard 在安全、隔离的本地沙箱中处理每次扫描。我们优先考虑通过零云遥测进行图像分析的可解释安全性。",
    "Mehr Guard strictly disables all outgoing telemetry. Your scan results, URL history, and image hashes never leave your device." to "Mehr Guard 严格禁用所有传出遥测。您的扫描结果、URL 历史记录和图像哈希永远不会离开您的设备。",
    "Mehr Guard uses local heuristic analysis engines. No image data, URL strings, or metadata leaves this device during scanning. Your privacy is mathematically guaranteed." to "Mehr Guard 使用本地启发式分析引擎。扫描期间不会有图像数据、URL 字符串或元数据离开此设备。您的隐私在数学上得到了保证。",
    "Mehr Guard works 100% offline! All analysis is done locally on your device. No internet connection required." to "[[品牌]] 100% 离线工作！所有分析均在您的设备上本地完成。无需互联网连接。",
    "Mehr Guard | Premium Web Scanner" to "[[品牌]] |高级网络扫描仪",
    "Mehr Guard Bot" to "二维码盾机器人",
    "Quarantine in Sandbox" to "沙箱隔离",
    "Quarantined in secure sandbox for analysis" to "隔离在安全沙箱中进行分析",
    "READY" to "准备好",
    "Randomly generated domains are often temporary phishing sites" to "随机生成的域通常是临时网络钓鱼站点",
    "Raw Image Buffer" to "原始图像缓冲区",
    "Read Only" to "只读",
    "Real-Time Scanning" to "实时扫描",
    "Real-time scanning" to "实时扫描",
    "Recent Scans" to "最近的扫描",
    "Recommended Actions" to "建议采取的行动",
    "Refresh Page" to "刷新页面",
    "Removed {domain} from {list}" to "从 {list} 中删除了 {domain}",
    "Removing or changing the suspicious pattern would reduce the overall risk score." to "删除或更改可疑模式将降低总体风险评分。",
    "Report Export - Mehr Guard" to "报告导出 - [[品牌]]",
    "Report Generation" to "报告生成",
    "Report Incorrect Verdict" to "举报错误判决",
    "Report Phishing" to "举报网络钓鱼",
    "Report URL copied to clipboard" to "报告 URL 已复制到剪贴板",
    "Report copied to clipboard" to "报告已复制到剪贴板",
    "Report if this verdict is wrong" to "报告此判决是否错误",
    "Report shared" to "报告已分享",
    "Report shared successfully!" to "报告分享成功！",
    "Reported: {timestamp}" to "报告：{timestamp}",
    "Reports" to "报告",
    "Reset Defaults" to "重置默认值",
    "Reset all Trust Centre settings to default?" to "将所有信任中心设置重置为默认值？",
    "Reset all settings to default" to "将所有设置重置为默认值",
    "Response" to "回复",
    "Result" to "结果",
    "Result # {id}" to "结果#{id}",
    "Result #8291-A" to "结果#8291-A",
    "Result copied to clipboard!" to "结果已复制到剪贴板！",
    "Results Dashboard" to "结果仪表板",
    "Return to Dashboard" to "返回仪表板",
    "Risk Assessment" to "风险评估",
    "Risk Score" to "风险评分",
    "Risk Score: {score}/100" to "风险评分：{score}/100",
    "Risk impact:" to "风险影响：",
    "Round" to "圆形的",
    "SAFE" to "安全",
    "SAFE TO VISIT" to "安全访问",
    "SMS from unknown number impersonating AusPost" to "来自冒充 AusPost 的未知号码的短信",
    "SSL Certificate Issues" to "SSL 证书问题",
    "SUSPICIOUS" to "可疑",
    "SUSPICIOUS ACTIVITY" to "可疑活动",
    "Safe" to "安全",
    "Safe Scans" to "安全扫描",
    "Safe to Visit" to "安全访问",
    "Safe vs Risky QR Codes" to "安全 vs有风险的二维码",
    "Safety Score" to "安全评分",
    "Save & Continue" to "保存并继续",
    "Scan" to "扫描",
    "Scan # {id}" to "扫描# {id}",
    "Scan #8021-AF" to "扫描#8021-AF",
    "Scan Another" to "扫描另一个",
    "Scan Complete" to "扫描完成",
    "Scan History" to "扫描历史",
    "Scan Meta" to "扫描元",
    "Scan Monitor" to "扫描监控",
    "Scan New QR" to "扫描新二维码",
    "Scan QR" to "扫描二维码",
    "Scan QR Code" to "扫描二维码",
    "Scan QR codes as they're detected" to "扫描检测到的二维码",
    "Scan Time" to "扫描时间",
    "Scan URLs Safely" to "安全扫描URL",
    "Scan history cleared" to "扫描历史记录已清除",
    "Scan this QR code with Mehr Guard to see malicious URL detection:" to "使用Mehr Guard扫描此二维码以查看恶意URL检测：",
    "Scanned with Mehr Guard - {url}" to "使用 Mehr Guard - {url}",
    "Scanner Dashboard" to "扫描仪仪表板",
    "Scanning..." to "扫描...",
    "Scans" to "扫描",
    "Scans for known malicious patterns and heuristic mismatches. Blocks homoglyph attacks and redirect chains. Low false positive rate expected." to "扫描已知的恶意模式和启发式不匹配。阻止同形文字攻击并重定向链。预计误报率较低。",
    "Secure Environment" to "安全环境",
    "Secure. Offline." to "安全。离线。",
    "Security" to "安全",
    "Security Analyst" to "安全分析师",
    "Security Audit: PASS" to "安全审核：通过",
    "Security Engine Active" to "安全引擎活动",
    "Security Heuristics" to "安全启发",
    "Security Settings" to "安全设置",
    "Security audit report downloaded" to "已下载安全审核报告",
    "See Results" to "查看结果",
    "See the difference instantly:" to "立即查看差异：",
    "Sensitivity Level" to "灵敏度级别",
    "Sensitivity set to {level}" to "灵敏度设置为 {level}",
    "Session ID: #GAME-" to "会话 ID：#GAME-",
    "Settings" to "设置",
    "Settings are saved automatically and sync across sessions." to "设置自动保存并在会话之间同步。",
    "Settings reset to default" to "设置重置为默认值",
    "Settings reset to defaults" to "设置重置为默认值",
    "Settings saved! Your data stays on-device." to "设置已保存！您的数据保留在设备上。",
    "Share" to "共享",
    "Share Report" to "共享报告",
    "Share detection stats to improve ML." to "共享检测统计信息以改进机器学习。",
    "Shared successfully!" to "共享成功！",
    "Sharing not supported" to "不支持共享",
    "Short URLs hide the actual destination. Prize claims from unknown numbers are almost always scams." to "短 URL 隐藏了实际目的地。来自未知号码的奖品索赔几乎总是骗局。",
    "Shortened URL hides true destination" to "缩短的 URL 隐藏了真正的目的地",
    "Show Confidence Score" to "显示置信度分数",
    "Show visual alerts for threats" to "显示威胁的可视警报",
    "Sign in to your GitHub account to access your repositories." to "登录到您的 GitHub 帐户以访问您的存储库。",
    "Signatures" to "签名",
    "Skip" to "跳过",
    "Some features may not work in your browser." to "某些功能可能无法在您的计算机中使用浏览器。",
    "Some minor security concerns were identified. The link appears mostly safe but review recommended." to "发现了一些小的安全问题。该链接看起来基本安全，但建议检查。",
    "Some suspicious indicators detected. Verify the source before entering sensitive information." to "检测到一些可疑指标。输入敏感信息之前请验证来源。",
    "Sound Alerts" to "声音警报",
    "Sound alerts" to "声音警报",
    "Source" to "来源",
    "Standard Gmail URL structure" to "标准 Gmail URL 结构",
    "Standard Google Docs URL format" to "标准 Google 文档 URL 格式",
    "Standard profile URL structure" to "标准个人资料 URL结构",
    "Status" to "状态",
    "Streak:" to "条纹：",
    "Strict" to "严格",
    "Strict Offline Guarantee" to "严格离线保证",
    "Strict Offline Mode" to "严格离线模式",
    "Strict Offline Mode disabled" to "禁用严格离线模式",
    "Strict Offline Mode enabled" to "启用严格离线模式",
    "Subdomain \"signin\" used for deception" to "用于子域“登录”欺骗",
    "Subdomain of google.com" to "google.com 子域",
    "Subdomain of google.com (trusted)" to "google.com 子域（受信任）",
    "Submitted via Mehr Guard" to "通过 Mehr Guard 提交",
    "Success!" to "成功！",
    "Support" to "支持",
    "Suspicious" to "可疑",
    "Suspicious Redirect Chain" to "可疑重定向链",
    "Suspicious TLD" to "可疑TLD",
    "Suspicious TLD (.tk)" to "可疑 TLD (.tk)",
    "Switch Language: English/Deutsch" to "切换语言：英语/德语",
    "Switched to {mode} mode" to "切换到 {mode} 模式",
    "System Health" to "系统运行状况",
    "System Secure" to "系统安全",
    "System Status" to "系统状态",
    "Systems Operational" to "系统运行",
    "TLD" to "TLD",
    "Target IP is located in a high-risk ASN." to "目标IP位于高风险ASN。",
    "Target URL" to "目标URL",
    "Technical Indicators" to "技术指标",
    "Technical Indicators:" to "技术指标：",
    "Terms" to "条款",
    "Test QR Code" to "测试二维码",
    "Thank you! Feedback recorded: Should be {verdict}" to "谢谢！记录的反馈：应该是 {verdict}",
    "The Kotlin/JS analysis engine is still loading or failed to initialize." to "Kotlin/JS 分析引擎仍在加载或初始化失败。",
    "The bot was faster this time. Try again!" to "这次机器人速度更快。再试一次！",
    "The destination URL employs" to "目标 URL 使用",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061)." to "该域使用西里尔文“а”(U+0430)，而不是拉丁文“a”(U+0061)。",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061). This technique is commonly used to trick users into believing they are visiting a legitimate service." to "该域使用西里尔文“а”(U+0430)，而不是拉丁文“a”(U+0061)。此技术通常用于欺骗用户，让他们相信他们正在访问合法服务。",
    "The entire threat signature database (100,000+ patterns) is stored locally for millisecond lookups without any network requests." to "整个威胁特征数据库（超过 100,000 个模式）存储在本地，无需任何网络请求即可进行毫秒级查找。",
    "The entire threat signature database is downloaded to your device for millisecond lookups." to "整个威胁特征数据库将下载到您的设备中进行毫秒级查找。",
    "The image doesn\\'t contain a recognizable QR code, or it may be damaged." to "图像不包含可识别的 QR 码，或者可能是已损坏。",
    "The input doesn\\'t appear to be a valid URL." to "输入的 URL 似乎不是有效的。",
    "The number 1 and lowercase L look identical in many fonts. Always verify paypal.com directly." to "数字 1 和小写 L 在许多字体中看起来相同。始终直接验证 paypal.com。",
    "The pattern matches known phishing characteristics" to "该模式与已知的网络钓鱼特征匹配",
    "The scanned QR code contains malicious indicators associated with phishing and credential harvesting. Do not proceed to the target URL." to "扫描的 QR 码包含与网络钓鱼和凭据收集相关的恶意指标。请勿继续访问目标 URL。",
    "The scanned QR code shows suspicious patterns that may indicate potential security risks. Proceed with caution." to "扫描的 QR 码显示可疑模式，可能表明存在潜在的安全风险。请谨慎行事。",
    "Think you can outsmart our AI? Try to craft a phishing URL that fools the detector!" to "您认为您可以智胜我们的人工智能吗？尝试制作一个欺骗检测器的网络钓鱼 URL！",
    "This URL passed all {count} security checks" to "此 URL 通过了所有 {count} 安全检查",
    "This URL triggered a security check" to "此 URL 触发了安全检查",
    "This URL was flagged by Mehr Guard\\'s offline phishing detection engine." to "此 URL 被 Mehr Guard\\ 的离线网络钓鱼检测引擎标记。",
    "This image was analysed locally on your device. No data was sent to the cloud for this verdict." to "此图像是在您的设备上本地分析的。对于此判决，没有数据发送到云端。",
    "This is a Google subdomain - check if it\\'s the legitimate Gmail service." to "这是 Google 子域 - 检查它是否是合法的 Gmail 服务。",
    "This is a security feature — your URLs never leave your device." to "这是一项安全功能 - 您的 URL 永远不会离开您的设备。",
    "This is a well-established software company domain." to "这是一个完善的软件公司域。",
    "This is the official LinkedIn domain for professional networking." to "这是用于专业网络的官方 LinkedIn 域。",
    "This may happen if: • You're using a very old browser • JavaScript is disabled • The page didn't fully load Try refreshing the page. If the issue persists, try Chrome, Firefox, or Safari." to "如果出现以下情况，可能会发生这种情况： • 您使用的是旧浏览器 • JavaScript 被禁用 • 页面未完全加载 尝试刷新页面。如果问题仍然存在，请尝试 Chrome、Firefox 或 Safari。",
    "This was actually {label}." to "这实际上是 {label}。",
    "This was {label}." to "这是 {label}。",
    "Threat Alerts" to "威胁警报",
    "Threat Analysis" to "威胁分析",
    "Threat Analysis Report" to "威胁分析报告",
    "Threat Confidence" to "威胁置信度",
    "Threat Database" to "威胁数据库",
    "Threat Detected" to "检测到威胁",
    "Threat Verdict" to "威胁判定",
    "Threat alerts" to "威胁警报",
    "Threat blocked and reported" to "已阻止并报告威胁",
    "Threat database is up to date" to "威胁数据库已更新",
    "Threat signatures updated to v2.4.1" to "威胁签名已更新为v2.4.1",
    "Threats" to "威胁",
    "Time" to "时间",
    "Tips for better scanning: • Ensure good lighting • Hold the camera steady • Fill the frame with the QR code • Avoid glare or reflections • Try uploading a clearer image" to "更好扫描的提示： • 确保良好的照明 • 稳定地握住相机 • 用二维码填充框架 • 避免眩光或反射 • 尝试上传更清晰的图像",
    "Today, 04:00 AM" to "今天凌晨 04:00",
    "Today, 14:32:05" to "今天， 14:32:05",
    "Today, {time}" to "今天，{time}",
    "Toggle Judge Mode" to "切换判断模式",
    "Toggle Language" to "切换语言",
    "Toggle Theme" to "切换主题",
    "Toggle light/dark mode" to "切换亮/暗模式",
    "Toggle menu" to "切换菜单",
    "Toggle theme" to "切换主题",
    "Top 100 Alexa Rank - whitelisted" to "前100名Alexa 排名 - 白名单",
    "Top 1k Alexa Rank whitelisted offline." to "前 1k Alexa 排名已离线列入白名单。",
    "Top Analysis Factors" to "热门分析因素",
    "Torch" to "Torch",
    "Torch error" to "Torch 错误",
    "Torch not available" to "Torch 不可用",
    "Torch off" to "Torch 关闭",
    "Torch on" to "Torch上",
    "Training" to "培训",
    "Training Centre" to "培训中心",
    "Trust Centre" to "信任中心",
    "Try Again" to "再试一次",
    "Try It Now!" to "立即尝试！",
    "Typosquatting" to "域名抢注",
    "Typosquatting Detected" to "检测到域名抢注",
    "Typosquatting pattern detected" to "域名抢注模式检测到",
    "UNKNOWN" to "未知",
    "URL" to "URL",
    "URL Shortener" to "URL缩短器",
    "URL Shortener Detected" to "检测到URL缩短器",
    "URL contains Cyrillic, Greek, or other lookalike Unicode characters" to "URL包含西里尔文、希腊语或其他相似的Unicode字符",
    "URL contains another URL in query parameters" to "URL在查询参数中包含另一个URL",
    "URL copied to clipboard!" to "URL已复制到剪贴板！",
    "URL exceeds 100 characters" to "URL超过100字符",
    "URL parsing (please update your browser)" to "URL 解析（请更新您的浏览器）",
    "URL pasted - press Enter to analyze" to "URL 粘贴 - 按 Enter 进行分析",
    "URL path contains /login, /signin, /verify, /secure, /account" to "URL 路径包含 /login、/signin、/verify、/secure、/account",
    "URL to analyze" to "要分析的 URL",
    "URL uses raw IP address instead of domain name" to "URL 使用原始 IP 地址而不是域名",
    "URL:" to "URL:",
    "URL: {url}" to "URL: {url}",
    "URL: {url}\\nVerdict: {verdict}\\nConfidence: {confidence}%" to "URL: {url}\\n结论: {verdict}\\n置信度: {confidence}%",
    "URLs are risky!" to "URL 有风险！",
    "Unable to determine verdict. Please try again." to "无法确定结论。请重试。",
    "Unknown" to "未知",
    "Unknown URL" to "未知网址",
    "Unknown Verdict" to "未知判决",
    "Unknown sender number" to "未知发件人号码",
    "Unsolicited prize notification" to "未经请求的奖品通知",
    "Upload" to "上传",
    "Upload Image" to "上传图像",
    "Upload Image Instead" to "上传图像",
    "Urgency tactics in message" to "紧急策略消息",
    "Use condensed layout for results" to "对结果使用压缩布局",
    "Users may not notice subtle character swaps like \"1\" for \"l\" or \"0\" for \"o\"" to "用户可能不会注意到微妙的字符交换，例如“1”代表“l”或“0”代表“o”",
    "Uses bit.ly, t.co, tinyurl, or similar shortening service" to "使用 bit.ly、t.co、tinyurl 或类似的缩短服务",
    "Uses high-risk TLDs like .tk, .ml, .ga, .cf, .xyz" to "使用高风险 TLD，例如 .tk、.ml、.ga、.cf、 .xyz",
    "VERIFIED SAFE" to "已验证安全",
    "VS" to "VS",
    "VS MODE" to "VS 模式",
    "Valid Extended Validation certificate" to "有效的扩展验证证书",
    "Valid Google certificate" to "有效的 Google 证书",
    "Valid SSL Certificate" to "有效的 SSL 证书",
    "Verdict" to "判决",
    "Verdict: {verdict}" to "判决： {verdict}",
    "VerdictPhish" to "VerdictPhish",
    "VerdictSafe" to "VerdictSafe",
    "VerdictWarn" to "VerdictWarn",
    "Verified by Mehr Guard Enterprise" to "由 Mehr Guard Enterprise 验证",
    "Verified by Mehr Guard Enterprise v{version}" to "由 Mehr Guard Enterprise v{version}",
    "Verified by local heuristics v2.4. No phishing patterns, obfuscated scripts, or blacklist matches found." to "由本地启发式 v2.4 验证。未找到网络钓鱼模式、混淆脚本或黑名单匹配项。",
    "Verifying..." to "正在验证...",
    "Version" to "版本",
    "Very High" to "非常高",
    "View All" to "查看全部",
    "View Full History" to "查看完整历史记录",
    "View Full Report" to "查看完整报告",
    "View John Smith\\'s professional profile on LinkedIn." to "在 LinkedIn 上查看约翰·史密斯的职业档案。",
    "View Security Audit" to "查看安全审计",
    "View detailed analysis in dashboard" to "在仪表板中查看详细分析",
    "Visual Appearance (What user sees)" to "视觉外观（用户看到的内容）",
    "WARN" to "警告",
    "Warning" to "警告",
    "We detect multiple attack types:" to "我们检测多种攻击类型：",
    "We strictly disable outgoing telemetry for scans. Scan results and image hashes remain local." to "我们严格禁用扫描的传出遥测。扫描结果和图像哈希保留在本地。",
    "Welcome to Jira - project tracking for agile teams." to "欢迎使用 Jira - 敏捷团队的项目跟踪。",
    "Welcome to Mehr Guard" to "欢迎来到[[品牌]]",
    "What it checks:" to "它检查什么：",
    "Why it matters:" to "为什么它很重要：",
    "Why the bot flagged it" to "为什么机器人会标记它",
    "Why this verdict?" to "为何做出这样的判决？",
    "Without other risk signals, login paths on safe domains would not increase score significantly." to "如果没有其他风险信号，安全域上的登录路径不会显着增加分数。",
    "Works 100% offline!" to "100% 离线工作！",
    "Workspace / Security / Reports" to "工作区/安全/报告",
    "Would you like to report this URL?\\n\\nOptions:\\n1. PhishTank - Click OK to open submission page\\n2. Email - Click Cancel to compose email\\n\\nURL: {url}" to "您想举报此 URL 吗？\\n\\n选项：\\n1. PhishTank - 单击“确定”打开提交页面\\n2.电子邮件 - 单击“取消”撰写电子邮件\\n\\nURL: {url}",
    "Wrong Verdict?" to "判决错误？",
    "Wrong!" to "错误的！",
    "Yesterday" to "昨天",
    "You" to "你",
    "You can still use Mehr Guard by uploading images or pasting URLs directly." to "您仍然可以通过上传图像或直接粘贴 URL 来使用 Mehr Guard。",
    "You can still use Mehr Guard: • Upload QR code images • Paste URLs directly • Use the sample URLs provided" to "您仍然可以使用 Mehr Guard： • 上传二维码图像 • 直接粘贴 URL • 使用提供的示例 URL",
    "You correctly identified this as {label}." to "您正确地将其识别为 {label}。",
    "You have 3 unread emails in your inbox." to "您的收件箱中有 3 封未读电子邮件。",
    "You identified the safe URL correctly." to "您正确识别了安全 URL。",
    "You spotted it correctly as {label}!" to "您正确地发现它是{label}！",
    "You spotted the phishing URL correctly." to "您正确发现了网络钓鱼 URL。",
    "You're offline — analysis still works!" to "您处于离线状态 — 分析仍然有效！",
    "You're reporting that this verdict may be wrong:" to "您报告此判决可能是错误的：",
    "You\\'re Offline" to "您当前离线",
    "Your Score" to "你的分数",
    "Your browser doesn\\'t support camera access, or you\\'re on a device without a camera." to "您的浏览器不支持相机访问，或者您使用的设备没有相机。",
    "Your data never leaves this device. All processing is local. No tracking, no uploads." to "您的数据永远不会离开此设备。所有处理都是本地的。没有跟踪，没有上传。",
    "Your data stays on-device." to "您的数据保留在设备上。",
    "\\nRisk Score:" to "\\n风险评分：",
    "a phishing attempt" to "网络钓鱼尝试",
    "actually legitimate" to "实际上合法",
    "bit.ly shortener" to "一点点缩短器",
    "characters often associated with phishing campaigns targeting financial institutions. The domain age is" to "通常与针对金融机构的网络钓鱼活动相关的角色。域名年龄为",
    "critical" to "批判的",
    "danger" to "危险",
    "for core services." to "为核心服务。",
    "high" to "高的",
    "homoglyph obfuscation" to "同形文字混淆",
    "in your browser." to "在您的浏览器中。",
    "just now" to "现在",
    "low" to "低的",
    "malicious" to "恶意的",
    "medium" to "中等的",
    "offline" to "离线",
    "online" to "在线的",
    "or click \"Upload\" to select a file" to "或点击“上传”选择文件",
    "phishing" to "网络钓鱼",
    "risk-badge danger" to "风险徽章危险",
    "risk-badge warning" to "风险徽章警告",
    "risk-item-expanded severity-" to "风险项目-扩展严重性-",
    "safe" to "安全的",
    "suspicious" to "可疑的",
    "to analyze," to "来分析，",
    "to focus," to "集中注意力，",
    "to reset" to "重置",
    "unknown" to "未知",
    "v2.4.1 •" to "v2.4.1 •",
    "warning" to "警告",
    "without compromising data privacy." to "不损害数据隐私。",
    "zero-latency phishing detection" to "零延迟网络钓鱼检测",
    "{date}, {time}" to "{date}、{time}",
    "{days} day ago" to "{days}天前",
    "{days} days ago" to "{days}天前",
    "{hours} hour ago" to "{hours} 小时前",
    "{hours} hours ago" to "{hours} 小时前",
    "{label} disabled" to "{label} 已禁用",
    "{label} enabled" to "{label} 已启用",
    "{level} Confidence" to "{level} 信心",
    "{minutes} minute ago" to "{minutes} 分钟前",
    "{minutes} minutes ago" to "{minutes} 分钟前",
    "{months} month ago" to "{months} 个月前",
    "{months} months ago" to "{months} 个月前",
    "{points} pts" to "{points} 分",
    "{title}: {summary}" to "{title}：{summary}",
    "{weeks} week ago" to "{weeks} 一周前",
    "{weeks} weeks ago" to "{weeks} 几周前",
    "© 2024 Mehr Guard Security Inc. All rights reserved." to "© 2024 [[品牌]] Security Inc. 保留所有权利。",
    "हिन्दी" to "हिन्दी",
    "⌨️ Tip: Press" to "⌨️提示：按",
    "⚠ Try Phishing URL" to "⚠ 尝试钓鱼网址",
    "✅ No data leaves your device" to "✅ 没有数据离开您的设备",
    "✅ Same engine as mobile apps" to "✅ 与移动应用程序相同的引擎",
    "✅ Works without internet" to "✅ 无需网络即可工作",
    "✓ No brand impersonation" to "✓ 严禁冒充品牌",
    "✓ No homograph attacks" to "✓ 无同形异义词攻击",
    "✓ No suspicious patterns" to "✓ 没有可疑模式",
    "✓ Safe TLD" to "✓ 安全顶级域名",
    "✓ Try Safe URL" to "✓ 尝试安全 URL",
    "日本語" to "日本语",
    "简体中文" to "简体中文",
    "🌐 Homograph attacks (Cyrillic chars)" to "🌐 同形异义词攻击（西里尔字母）",
    "🎉 You Win!" to "🎉你赢了！",
    "🎬 Demo Mode: Click \"Analyze URL\" to see detection" to "🎬 演示模式：点击“分析URL”查看检测",
    "🎮 Craft a sneaky phishing URL..." to "🎮 制作一个偷偷摸摸的网络钓鱼 URL...",
    "🎮 Game Mode: Try to craft a URL that gets detected as SAFE!" to "🎮 游戏模式：尝试创建一个被检测为安全的 URL！",
    "🏆 Players challenged:" to "🏆 挑战的玩家：",
    "🏆 You beat the bot! Score: {score}/{attempts}" to "🏆 你打败了机器人！分数：{score}/{attempts}",
    "💡 What would reduce this?" to "💡什么可以减少这个？",
    "🔒 100% offline • Zero data collection • Open source (Apache 2.0)" to "🔒 100% 离线 • 零数据收集 • 开源 (Apache 2.0)",
    "🔒 Zero data collection • 🚀 Same engine as Android & iOS • 🧠 Ensemble ML (25+ heuristics)" to "🔒 零数据收集 • 🚀 与 Android 和 iOS 相同的引擎 • 🧠 Ensemble ML（25+ 启发式）",
    "🔗 URL shortener obfuscation" to "🔗 URL缩短器混淆",
    "🔤 Typosquatting (paypa1 → paypal)" to "🔤 误植 (paypa1 → paypal)",
    "🛡️ Mehr Guard Analysis" to "🛡️ [[品牌]] 分析",
    "🛡️ Mehr Guard — Kotlin Multiplatform QRishing Detector" to "🛡️ [[品牌]] — Kotlin 多平台 QRishing 检测器",
    "🤖 Bot wins! Phishing detected. Score: {score}/{attempts}" to "🤖 机器人获胜！检测到网络钓鱼。分数：{score}/{attempts}",
    "🧑‍⚖️ Demo: Forced MALICIOUS result" to "🧑‍⚖️ 演示：强制恶意结果",
    "🧑‍⚖️ Judge Mode ON - All URLs will show MALICIOUS" to "🧑‍⚖️ 裁判模式开启 - 所有 URL 将显示恶意",
    "🧑‍⚖️ Judge Mode activated - Demo history loaded!" to "🧑‍⚖️ 裁判模式已激活 - 演示历史记录已加载！",
    "🧪 Try these examples:" to "🧪 尝试以下示例：",
    "Added {date}" to "添加于{date}",
    "Analyzing..." to "分析中...",
    "Camera N/A" to "相机不可用",
    "Error analyzing URL: {error}" to "分析 URL 时出错：{error}",
    "Challenge Mehr Guard's offline AI engine. Can you spot phishing URLs faster than the bot?" to "挑战 Mehr Guard 的离线 AI 引擎。你能比机器人更快识别钓鱼 URL 吗？",
    "Paste URL to analyze (e.g., https://example.com)" to "粘贴要分析的 URL（例如 https://example.com）",
    "Mehr Guard Active Scanner - Real-time QR code scanning with AI-powered phishing detection." to "Mehr Guard 活动扫描器——使用 AI 的实时二维码扫描与钓鱼检测。",
    "Mehr Guard Dashboard - Enterprise offline QR code security with explainable threat detection." to "Mehr Guard 仪表板——企业级离线二维码安全，具备可解释的威胁检测。",
    "Mehr Guard Privacy Settings - 100% offline protection with zero cloud telemetry." to "Mehr Guard 隐私设置——100% 离线保护，无云端遥测。",
    "Mehr Guard Report Export - Generate and download threat analysis reports in PDF or JSON format." to "Mehr Guard 报告导出——生成并下载 PDF 或 JSON 格式的威胁分析报告。",
    "Mehr Guard Threat Analysis - Detailed scan result showing attack breakdown and security recommendations." to "Mehr Guard 威胁分析——显示攻击分解和安全建议的详细扫描结果。",
    "Mehr Guard Trust Centre - Manage privacy controls, detection sensitivity, and security lists." to "Mehr Guard 信任中心——管理隐私控制、检测灵敏度和安全列表。",
    "Mehr Guard Web - AI-powered phishing detection running entirely in your browser. Scan and analyze URLs for security threats." to "Mehr Guard Web——在浏览器内完全运行的 AI 钓鱼检测。扫描并分析 URL 以发现安全威胁。",
    "Mehr Guard scan results - AI-powered phishing detection with detailed security analysis." to "Mehr Guard 扫描结果——带有详细安全分析的 AI 钓鱼检测。",
    "why" to "为什么",
    "heuristics" to "启发式",
    "redirects" to "重定向",
    "ssl_issuer" to "ssl_签发者",
    "subdomain_chaining" to "子域名链",
    "suspicious_tld" to "可疑_tld",
    "threat_type" to "威胁类型",

    // Accessibility & Settings keys (sync with other languages)
    WebStringKey.AutoBlockThreats to "自动拦截威胁",
    WebStringKey.CloseMenuModal to "关闭菜单/对话框",
    WebStringKey.CompactView to "紧凑视图",
    WebStringKey.GotIt to "知道了",
    WebStringKey.KeyboardShortcuts to "键盘快捷键",
    WebStringKey.NavigateToDashboard to "前往仪表板",
    WebStringKey.NavigateToGame to "智斗机器人游戏",
    WebStringKey.NavigateToHistory to "扫描历史",
    WebStringKey.NavigateToTrust to "信任中心/白名单",
    WebStringKey.RealTimeScanning to "实时扫描",
    WebStringKey.ResetDefaults to "恢复默认",
    WebStringKey.SaveAndContinue to "保存并继续",
    WebStringKey.SecuritySettings to "安全设置",
    WebStringKey.SensitivityLevel to "灵敏度级别",
    WebStringKey.ShowConfidenceScore to "显示置信度分数",
    WebStringKey.ShowHelp to "显示帮助",
    WebStringKey.SoundAlerts to "声音提醒",
    WebStringKey.StartScanner to "启动扫描器",
    WebStringKey.ThreatAlerts to "威胁警报",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "可疑活动",
    WebStringKey.VerdictWarning to "警告",
    WebStringKey.VerdictSuspiciousDesc to "扫描的二维码显示可疑模式，可能表明存在潜在安全风险。请谨慎操作。",
    WebStringKey.VerdictMinorConcerns to "轻微问题",
    WebStringKey.VerdictCaution to "注意",
    WebStringKey.VerdictMinorConcernsDesc to "发现了一些轻微的安全问题。链接看起来基本安全，但建议进行审查。",
    WebStringKey.VerdictVerifiedSafe to "已验证安全",
    WebStringKey.VerdictSafeLabel to "安全",
    WebStringKey.VerdictVerifiedSafeDesc to "未检测到安全威胁。二维码指向经过验证的安全目的地。",
    WebStringKey.VerdictNoActivity to "无活动",
    WebStringKey.VerdictAwaitingScan to "等待扫描",
    WebStringKey.VerdictNoActivityDesc to "没有可用的扫描数据。请扫描二维码或输入URL进行分析。",
    WebStringKey.ScanQrToSeeActivity to "扫描二维码以在此处查看您的活动",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "数据点",
    WebStringKey.ProcessingEnv to "处理环境",
    WebStringKey.ExternalTransmission to "外部传输",
    WebStringKey.RawImageBuffer to "原始图像缓冲区",
    WebStringKey.LocalMemoryRam to "本地内存 (RAM)",
    WebStringKey.TransmissionNone to "无",
    WebStringKey.DecodedUrlPayload to "解码的URL/载荷",
    WebStringKey.LocalAnalysis to "本地分析",
    WebStringKey.ThreatVerdictLabel to "威胁判定",
    WebStringKey.LocalDatabase to "本地数据库",
    
    // Reason Code Titles and Descriptions
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "检测到JavaScript URL方案 - 点击时会执行代码",
    WebStringKey.ReasonDataUriTitle to "数据URI",
    WebStringKey.ReasonDataUriDesc to "检测到数据URI方案 - 可能包含嵌入的恶意代码",
    WebStringKey.ReasonAtSymbolInjectionTitle to "@符号注入",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL包含@符号，表明可能存在凭证窃取尝试",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "同形异义字攻击",
    WebStringKey.ReasonHomographDesc to "国际化域名(IDN)可能在模仿另一个域名",
    WebStringKey.ReasonMixedScriptTitle to "混合脚本",
    WebStringKey.ReasonMixedScriptDesc to "主机名包含来自不同书写系统的字符（可能是欺骗）",
    WebStringKey.ReasonLookalikeCharsTitle to "相似字符",
    WebStringKey.ReasonLookalikeCharsDesc to "域名包含类似ASCII字母的Unicode字符",
    WebStringKey.ReasonZeroWidthCharsTitle to "零宽字符",
    WebStringKey.ReasonZeroWidthCharsDesc to "检测到隐藏的零宽Unicode字符（混淆尝试）",
    WebStringKey.ReasonIpHostTitle to "IP主机",
    WebStringKey.ReasonIpHostDesc to "URL使用IP地址而不是域名",
    WebStringKey.ReasonCredentialParamTitle to "凭证参数",
    WebStringKey.ReasonCredentialParamDesc to "URL包含与凭证相关的参数（密码、令牌等）",
    WebStringKey.ReasonBrandImpersonationTitle to "品牌冒充",
    WebStringKey.ReasonBrandImpersonationDesc to "URL似乎在冒充知名品牌",
    WebStringKey.ReasonBrandInSubdomainTitle to "子域名中的品牌",
    WebStringKey.ReasonBrandInSubdomainDesc to "品牌名称出现在子域名中但不在主域名中",
    WebStringKey.ReasonRiskyExtensionTitle to "危险扩展名",
    WebStringKey.ReasonRiskyExtensionDesc to "路径包含潜在危险的文件扩展名",
    WebStringKey.ReasonDoubleExtensionTitle to "双重扩展名",
    WebStringKey.ReasonDoubleExtensionDesc to "检测到双重文件扩展名（常见的恶意软件策略）",
    WebStringKey.ReasonEncodedPayloadTitle to "编码载荷",
    WebStringKey.ReasonEncodedPayloadDesc to "在URL参数中检测到大量编码数据",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP而非HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL使用不安全的HTTP协议而不是HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "可疑顶级域",
    WebStringKey.ReasonSuspiciousTldDesc to "该顶级域经常用于钓鱼",
    WebStringKey.ReasonHighEntropyHostTitle to "高熵主机",
    WebStringKey.ReasonHighEntropyHostDesc to "域名似乎是随机生成的",
    WebStringKey.ReasonRedirectParamTitle to "重定向参数",
    WebStringKey.ReasonRedirectParamDesc to "URL包含可能导向其他站点的重定向参数",
    WebStringKey.ReasonDeepSubdomainTitle to "深层子域名",
    WebStringKey.ReasonDeepSubdomainDesc to "子域名深度过深（可能隐藏真实域名）",
    WebStringKey.ReasonMultiTldTitle to "多重顶级域",
    WebStringKey.ReasonMultiTldDesc to "域名中包含多个类似顶级域的段",
    WebStringKey.ReasonNumericSubdomainTitle to "数字子域名",
    WebStringKey.ReasonNumericSubdomainDesc to "检测到纯数字子域名",
    WebStringKey.ReasonNonStandardPortTitle to "非标准端口",
    WebStringKey.ReasonNonStandardPortDesc to "URL使用非标准端口号",
    WebStringKey.ReasonSuspiciousPortTitle to "可疑端口",
    WebStringKey.ReasonSuspiciousPortDesc to "URL使用通常与攻击相关的端口",
    WebStringKey.ReasonFragmentHidingTitle to "片段隐藏",
    WebStringKey.ReasonFragmentHidingDesc to "URL片段似乎隐藏了额外内容",
    WebStringKey.ReasonExcessiveEncodingTitle to "过度编码",
    WebStringKey.ReasonExcessiveEncodingDesc to "检测到过度URL编码（混淆尝试）",
    WebStringKey.ReasonDomainAgePatternTitle to "域名年龄模式",
    WebStringKey.ReasonDomainAgePatternDesc to "域名匹配自动生成域名的模式",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "URL缩短器",
    WebStringKey.ReasonUrlShortenerDesc to "URL使用缩短服务（隐藏真实目的地）",
    WebStringKey.ReasonSuspiciousPathTitle to "可疑路径",
    WebStringKey.ReasonSuspiciousPathDesc to "路径包含可疑关键词（登录、验证等）",
    WebStringKey.ReasonLongUrlTitle to "长URL",
    WebStringKey.ReasonLongUrlDesc to "URL异常长",
    WebStringKey.ReasonCredentialKeywordsTitle to "凭证关键词",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL包含凭证收集关键词",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "无法解析的URL",
    WebStringKey.ReasonUnparseableDesc to "URL无法完全解析",
    WebStringKey.ReasonAnalysisCompleteTitle to "分析完成",
    WebStringKey.ReasonAnalysisCompleteDesc to "分析成功完成",
    
    // ML Score Labels
    WebStringKey.MlPhishingScore to "ML钓鱼评分",
    WebStringKey.MlCharacterAnalysis to "字符分析",
    WebStringKey.MlFeatureAnalysis to "特征分析",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "IDN / Punycode 域名",
    WebStringKey.IdnPunycodeDomainDesc to "此域名使用国际化字符。安全显示：",
    WebStringKey.MixedScriptAttackTitle to "混合脚本攻击",
    WebStringKey.MixedScriptAttackDesc to "域名包含来自多种文字的字符（如西里尔文 + 拉丁文）。常见于同形异义字攻击。",
    WebStringKey.ConfusableCharsTitle to "易混淆字符",
    WebStringKey.ConfusableCharsDesc to "域名包含与常见字母相似的字符（如 'а' vs 'a'）。"
)
